import React, { useState, useEffect, useRef } from "react";
import HeaderAdmin from "../../src/Components/HeaderAdmin/Header";
import { Tab, Form, Accordion, Nav } from "react-bootstrap";
import { FaAngleUp, FaCalendarAlt, FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../Api/auth";
import { Spinner } from "react-bootstrap";
import { updatefitter } from "../Api/staff";
import { getallremotefittinginquiresbyfitter } from "../Api/iron";
import { IoCloseSharp, IoResize } from "react-icons/io5";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";
import Tabs from "react-bootstrap/Tabs";
import { IoMdEye } from "react-icons/io";
import Modal from "react-bootstrap/Modal";
import { IoClose } from "react-icons/io5";
import {
  getallModeldatabymake,
  getInventoryByTypeWithShaftAndGrip,
} from "../Api/inventoryApi";
import {
  getremoteInquirydataApi,
  createposts,
  getpostsbyfitter,
  updatepost,
  getcountries,
  getcountriesforfitter,
  getstates,
  getcities,
  removepost
} from "../Api/iron";
import { API_URL } from "../Api/config";
import { FiImage, FiUpload } from "react-icons/fi";
import Button from 'react-bootstrap/Button';

const initData = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  height_ft: "",
  height_in: "",
  wrist_to_floor: "",
  shoulder_to_wrist: "",
  elbow_to_wrist: "",
  fitter_name: "",
};

function Fitter() {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [apicall, setApicall] = useState(false);
  const [user_id, setUser_id] = useState(0);
  const [validated, setValidated] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [dataNull, setDataNull] = useState(null);

  const [databaseimage, setDatabaseImage] = useState(null);
  const [databasecoverimage, setdatabaseCoverImage] = useState(null);
  const [databasebiovideo, setdatabaseBioVideo] = useState(null);



  const [userdata, setUserdata] = React.useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    website_url: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    bio: "",
  });

  console.log("userdatauserdata", userdata);
  const [edittrue, setEdittrue] = useState(false);

  const handleedittrue = () => {
    setEdittrue(!edittrue);
  };

  useEffect(() => {
    getallModels();
    getmakedata(1);
    getallcountry();
    const getCurrentUserdata = getCurrentUser();
    // setUserdata(getCurrentUserdata.user);
    // setUser_id(getCurrentUserdata.user._id);
    if (getCurrentUserdata && getCurrentUserdata.user) {
      setUserdata(getCurrentUserdata.user);
      setUser_id(getCurrentUserdata.user._id);
      getprojectforfitter(getCurrentUserdata.user._id);
      getallpostfunc(getCurrentUserdata.user._id);
      getallstatefunc(getCurrentUserdata.user.country);
      getallcityfunc(getCurrentUserdata.user.state);
      setdatabaseCoverImage(getCurrentUserdata.user.cover_image);
      setDatabaseImage(getCurrentUserdata.user.profile_image);
      setdatabaseBioVideo(getCurrentUserdata.user.bioVideo);
    } else {
      console.error("Current user data is null or undefined");
    }
  }, []);

  const dataChange = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
  };

  const handleUpdateSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    console.log("userdatauserdata update", userdata);
    // userdata._id = user_id;

    const formdata = new FormData();
    formdata.append("firstname", userdata.firstname);
    formdata.append("lastname", userdata.lastname);
    formdata.append("email", userdata.email);
    formdata.append("phone", userdata.phone);
    formdata.append("website_url", userdata.website_url);
    formdata.append("address", userdata.address);
    formdata.append("city", userdata.city);
    formdata.append("state", userdata.state);
    formdata.append("zip", userdata.zip);
    formdata.append("country", userdata.country);
    formdata.append("bio", userdata.bio);
    formdata.append("image", profileImage);
    formdata.append("cover_image", coverImage);
    formdata.append("bio_video", bioVideo);
    formdata.append("_id", user_id);

    updatefitter(formdata, e)
      .then((res) => {
        console.log(res);
        if (!res.data.status) {
          setErrors(res.data.error);
          alert(res.data.message);
        } else {
          localStorage.setItem("user", JSON.stringify(res.data.data));
          const formdata = res.data.data.user;
          setUserdata(formdata);
        }
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {
        setApicall(false);
        setEdittrue(false);
        setIsLoading(false);
      });
    setValidated(true);
  };

  const getprojectforfitter = (id) => {
    setApicall(true);
    setIsLoading(true);

    const data = {
      _id: id,
    };
    getallremotefittinginquiresbyfitter(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setFilteredData(data);
          setDataNull(!null);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApicall(false);
        setIsLoading(false);
      });
  };

  const handleCloseConfirmation2 = () => setShowConfirmation2(false);
  const handleShowConfirmation2 = () => setShowConfirmation2(true);
  const [showConfirmation2, setShowConfirmation2] = useState(false);
  const [status, setStatus] = useState("");
  const [customername, setCustomername] = useState("");
  const [remortFittingFormData, setRemortFittingFormData] = useState(initData);

  const showstagespopup = () => {
    handleShowConfirmation2();
  };

  const [checktype, setChecktype] = useState("0");

  //New code
  const initialPrescriptionStateNew = {
    bounce: "",
    lieage: "",
    shaftweight: "",
    shaftflex: "",
    shaftprofile: "",
    gripSize: "",
    clubLength: "",
    swingWeight: "",

    bounceselect: "",
    lieageselect: "",
    shaftweightselect: "",
    shaftflexselect: "",
    shaftprofileselect: "",
    gripSizeselect: "",
    clubLengthselect: "",
    swingWeightselect: "",
  };

  const [prescriptionNew, setPrescriptionNew] = useState(
    initialPrescriptionStateNew
  );

  const [optimalHeads, setOptimalHeads] = useState(0);
  const [optimalShafts, setOptimalShafts] = useState(0);
  const [optimalGrips, setOptimalGrips] = useState(0);

  useEffect(() => {
    if (remortFittingFormData) {
      setPrescriptionNew(remortFittingFormData?.fittingdata);
      setOptimalHeads(parseInt(remortFittingFormData?.optimalHeadsStar));
      setOptimalShafts(parseInt(remortFittingFormData?.optimalShaftsStar));
      setOptimalGrips(parseInt(remortFittingFormData?.optimalGripsStar));
    }
  }, [remortFittingFormData]);

  const getselectbounce = (category, value) => {
    const selectedValue = parseInt(value);

    // Define options for each category
    const options = {
      bounce: {
        1: "Low Bounce",
        2: "Mid Bounce",
        3: "High Bounce",
      },
      lieAngle: {
        1: "Upright",
        2: "Standard",
        3: "Flat",
      },
      shaftWeight: {
        1: "Heavy",
        2: "Medium",
        3: "Light",
      },
      shaftFlex: {
        1: "Hard",
        2: "Medium",
        3: "Soft",
      },
      shaftProfile: {
        1: "Firm Tip",
        2: "Soft Mid",
        3: "Firm Butt",
      },
      gripSize: {
        1: "Oversize",
        2: "Mid",
        3: "Standard",
      },
      clubLength: {
        1: "Long",
        2: "Medium",
        3: "Short",
      },
      swingWeight: {
        1: "Heavy",
        2: "Medium",
        3: "Light",
      },
    };

    // Return the option label based on category and selected value
    return (
      options[category]?.[selectedValue] ||
      `Select ${category.replace(/([A-Z])/g, " $1").trim()}`
    );
  };

  const [optimalHeadsobject, setOptimalHeadsobject] = useState({
    option1: { make: "", model: "" },
    option2: { make: "", model: "" },
    option3: { make: "", model: "" },
  });

  const [optimalShaftsobject, setOptimalShaftsobject] = useState({
    option1: { make: "", model: "" },
    option2: { make: "", model: "" },
    option3: { make: "", model: "" },
  });

  const [optimalGripsobject, setOptimalGripsobject] = useState({
    option1: { make: "", model: "" },
    option2: { make: "", model: "" },
    option3: { make: "", model: "" },
  });

  useEffect(() => {
    if (remortFittingFormData?.optimalHeads) {
      setOptimalHeadsobject((prevState) => ({
        ...prevState, // Preserve any existing data
        ...remortFittingFormData.optimalHeads, // Update with new data
      }));

      setOptimalHeads(Number(remortFittingFormData?.optimalHeadsStar));
    }

    if (remortFittingFormData?.optimalShafts) {
      setOptimalShaftsobject((prevState) => ({
        ...prevState,
        ...remortFittingFormData.optimalShafts,
      }));

      setOptimalShafts(Number(remortFittingFormData?.optimalShaftsStar));
    }

    if (remortFittingFormData?.optimalGrips) {
      setOptimalGripsobject((prevState) => ({
        ...prevState,
        ...remortFittingFormData.optimalGrips,
      }));
      setOptimalGrips(Number(remortFittingFormData?.optimalGripsStar));
    }

    //also check
  }, [remortFittingFormData]);

  const [head1, setHead1] = useState("");
  const [head2, setHead2] = useState("");
  const [head3, setHead3] = useState("");

  const [Shaft1, setShaft1] = useState("");
  const [Shaft2, setShaft2] = useState("");
  const [Shaft3, setShaft3] = useState("");

  const [Grip1, setGrip1] = useState("");
  const [Grip2, setGrip2] = useState("");
  const [Grip3, setGrip3] = useState("");

  const [allmodels, setAllModels] = useState([]);

  const [makedata, setMakeData] = useState([]);
  const [shaftdata, setShaftData] = useState([]);
  const [gripdata, setGripData] = useState([]);

  const handleNestedChange = (section, option, subField, value) => {
    if (allmodels.length > 0) {
      const optionKey = `option${option}`;
      let type_id = "";
      switch (section) {
        case "optimalHeads":
          type_id = "4";
          break;
        case "optimalShafts":
          type_id = "7";
          break;
        case "optimalGrips":
          type_id = "8";
          break;
        default:
          break;
      }

      // Filter the models from allmodels array
      const filteredModels = allmodels.filter(
        (model) => model.Make === value && model.type_id === type_id
      );

      // Set the data based on section, subField, and option
      if (filteredModels.length > 0) {
        const data = filteredModels;

        if (section === "optimalHeads") {
          switch (option) {
            case 1:
              console.log("head 1", data);
              setHead1(data);
              break;
            case 2:
              setHead2(data);
              break;
            case 3:
              setHead3(data);
              break;
            default:
              break;
          }
        }

        if (section === "optimalShafts") {
          switch (option) {
            case 1:
              setShaft1(data);
              break;
            case 2:
              setShaft2(data);
              break;
            case 3:
              setShaft3(data);
              break;
            default:
              break;
          }
        }

        if (section === "optimalGrips") {
          switch (option) {
            case 1:
              setGrip1(data);
              break;
            case 2:
              setGrip2(data);
              break;
            case 3:
              setGrip3(data);
              break;
            default:
              break;
          }
        }

        const updateData = (setFunction, currentData) => {
          setFunction((prevData) => ({
            ...prevData,
            [optionKey]: {
              // Update the correct option (option1, option2, option3)
              ...prevData[optionKey],
              [subField]: value, // Update the specific field (make or model)
            },
          }));
        };

        // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
        if (section === "optimalHeads") {
          updateData(setOptimalHeadsobject, optimalHeadsobject);
        } else if (section === "optimalShafts") {
          updateData(setOptimalShaftsobject, optimalShaftsobject);
        } else if (section === "optimalGrips") {
          updateData(setOptimalGripsobject, optimalGripsobject);
        }
      }
    }
  };

  useEffect(() => {
    if (allmodels.length > 0 && remortFittingFormData) {
      handleNestedChange(
        "optimalHeads",
        1,
        "make",
        remortFittingFormData?.optimalHeads?.option1?.make
      );
      handleNestedChange(
        "optimalHeads",
        2,
        "make",
        remortFittingFormData?.optimalHeads?.option2?.make
      );
      handleNestedChange(
        "optimalHeads",
        3,
        "make",
        remortFittingFormData?.optimalHeads?.option3?.make
      );

      handleNestedChange(
        "optimalShafts",
        1,
        "make",
        remortFittingFormData?.optimalShafts?.option1?.make
      );
      handleNestedChange(
        "optimalShafts",
        2,
        "make",
        remortFittingFormData?.optimalShafts?.option2?.make
      );
      handleNestedChange(
        "optimalShafts",
        3,
        "make",
        remortFittingFormData?.optimalShafts?.option3?.make
      );

      handleNestedChange(
        "optimalGrips",
        1,
        "make",
        remortFittingFormData?.optimalGrips?.option1?.make
      );
      handleNestedChange(
        "optimalGrips",
        2,
        "make",
        remortFittingFormData?.optimalGrips?.option2?.make
      );
      handleNestedChange(
        "optimalGrips",
        3,
        "make",
        remortFittingFormData?.optimalGrips?.option3?.make
      );
    }
  }, [allmodels, remortFittingFormData]);

  const getallModels = () => {
    getallModeldatabymake()
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setAllModels(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getmakedata = (id) => {
    const data = {
      type_id: id,
    };
    getInventoryByTypeWithShaftAndGrip(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setMakeData(data.makeData);
          setShaftData(data.shaftdata);
          setGripData(data.gripdata);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getremoteInquiryapifunc = (id) => {
    setIsLoading(true);
    const data = {
      id: id,
    };
    getremoteInquirydataApi(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setRemortFittingFormData(data);
          showstagespopup();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApicall(false);
        setIsLoading(false);
      });
  };

  const [postdata, setPostData] = useState([]);
  const fileInputRef = useRef(null);
  const [activepost, setActivepost] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const [image, setimage] = useState(null);
  const [title, setTitle] = useState("");
  const [descripation, setDescripation] = useState("");

  const [postsloader, setPostLoader] = useState(false);

  const handleSubmit = (event) => {
    setPostLoader(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setPostLoader(false);
    } else {
      event.preventDefault();

      const formdata = new FormData();
      formdata.append("title", title);
      formdata.append("descripation", descripation);
      formdata.append("image", image);
      formdata.append("fitter_id", user_id);

      createposts(formdata)
        .then((response) => {
          if (!response.data.status) {
            setErrors(response.data.error);
          } else {
            const data = response.data.data;
            setTitle("");
            setDescripation("");
            setimage(null);
            setImagePreview(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            setActivepost(false);
            getallpostfunc(user_id);
            setValidated(false);
            setPostLoader(false);
            // setRemortFittingFormData(data);
          }
        })
        .catch((err) => {
          console.log(err);
          setPostLoader(false);
        });
    }
    setValidated(true);
  };

  const removepostdata = () => {
    setTitle("");
    setDescripation("");
    setimage(null);
    setActivepost(false);
  };

  const getallpostfunc = (userid) => {
    setIsLoading(true);
    const data = {
      fitter_id: userid,
    };
    getpostsbyfitter(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setPostData(data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApicall(false);
        setIsLoading(false);
      });
  };

  const [editIndex, setEditIndex] = useState(null);
  const [editedPost, setEditedPost] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedPost((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    setEditedPost((prev) => ({ ...prev, post_image: e.target.files[0] }));
  };

  const handleCancel = () => {
    setEditIndex(null);
  };

  const handleEditClick = (index, post) => {
    setEditIndex(index);
    setEditedPost({ ...post });
  };

  const [UpdatePostLoader, setUpdatePostLoader] = useState(false);

  const handleSave = () => {
    setUpdatePostLoader(true);
    const formdata = new FormData();
    formdata.append("title", editedPost?.title);
    formdata.append("descripation", editedPost?.descripation);
    formdata.append("image", editedPost?.post_image);
    formdata.append("fitter_id", user_id);
    formdata.append("id", editedPost?._id);

    updatepost(formdata)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
        } else {
          const data = response.data.data;
          setEditIndex(null);
          getallpostfunc(user_id);
          setValidated(false);
          setUpdatePostLoader(false);
          // setRemortFittingFormData(data);
        }
      })
      .catch((err) => {
        console.log(err);
        setUpdatePostLoader(false);
      });
  };

  const [stateLoading, setStateLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);

  const [countrylist, setCountrylist] = useState([]);
  const [statelist, setStatelist] = useState([]);
  const [citylist, setCitylist] = useState([]);

  const getallcountry = () => {
    getcountriesforfitter()
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setCountrylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallstatefunc = (country_id) => {
    setStateLoading(true);
    const data = {
      country_id: country_id,
    };
    getstates(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setStateLoading(false);
          const data = response.data.data;
          setStatelist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallcityfunc = (state_id) => {
    setCityLoading(true);
    const data = {
      state_id: state_id,
    };
    getcities(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setCityLoading(false);
          const data = response.data.data;
          setCitylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleactivepost = () => {
    setActivepost(true);
  };

  const [profileImage, setProfileImage] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [bioVideo, setBioVideo] = useState(null);

  const handleProfileImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProfileImage(e.target.files[0]);
    }
  };

  const handleCoverImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setCoverImage(e.target.files[0]);
    }
  };

  const handleBioVideo = (e) => {
    if (e.target.files && e.target.files[0]) {
      setBioVideo(e.target.files[0]);
      setdatabaseBioVideo(null);
    }
  };

  const [showremovepostpop, setShowremovepostpop] = useState(false);
  const handleCloseremovepostpopup = () => setShowremovepostpop(false);
  const handleShowremovepostpop = () => setShowremovepostpop(true);

  const [postId, setPostId] = useState(0);

  const [postdeleteloader, setPostdeleteloader] = useState(false);


  const removepostfunc = () => {
    setPostdeleteloader(true);
    const data = {
      id: postId,
    };
    removepost(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setPostdeleteloader(false)
          handleCloseremovepostpopup();
          getallpostfunc(user_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <Loader2 />
        </div>
      ) : (
        <>

          <Modal
            show={showremovepostpop}
            onHide={handleCloseremovepostpopup}
            centered
            id="success_tic"
            className='model-thank-you'
          >
            <Modal.Body>
              <div className="logo-modal mb-4 text-center">
                <img src={require('../assets/images/logo_text.png')} alt="logo" />
              </div>
              <div className="confirmation-content text-center">
                <h4>Are you sure you want to remove a post?</h4>
                <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                  {
                    postdeleteloader ? (<Button variant="success" disabled style={{ maxWidth: "3.5rem" }}>
                      deleting...
                    </Button>) : (<Button variant="success" onClick={removepostfunc} style={{ maxWidth: "3.5rem" }}>
                      Yes
                    </Button>)
                  }
                  {' '}
                  <Button variant="danger" onClick={() => {
                    handleCloseremovepostpopup();
                  }} style={{ maxWidth: "3.5rem" }}>
                    No
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div className="main-page-body-content-header">
            <HeaderAdmin />
          </div>
          <div className="design_show_mobile">
            <div className="fixed-btn">
              <Link to="/fitter-customer">
                <svg
                  fill="none"
                  height="64"
                  viewBox="0 0 64 64"
                  width="64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="#1e2024">
                    <path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" />
                    <path
                      clip-rule="evenodd"
                      d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z"
                      fill-rule="evenodd"
                    />
                  </g>
                </svg>
              </Link>
            </div>
          </div>

          <Modal
            centered
            show={showConfirmation2}
            onHide={handleCloseConfirmation2}
            className="card-radius popup-modal-dark add_club_modal new-project-modal align-center p-0 "
          >
            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile cewfefew m-0">
              <div className="close-modal">
                <div className="custom-modal-header">
                  <h3 className="text mb-3">Project View</h3>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseConfirmation2}
                    aria-label="Close"
                  >
                    <IoClose />
                  </button>
                </div>
              </div>

              <div className="modal-long-form">
                <div className="black_bg_box progress-box vwfefe mt-3">
                  <button type="button" className="btn-header-transparent">
                    <div className="d-flex align-items-center">
                      <div className="border_box_view_inner ms-0">
                        <div className="box_icon">
                          <svg
                            viewBox="-42 0 512 512.002"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#99ea24"
                          >
                            <path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                            <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                          </svg>
                        </div>
                        <div className="box_text_content mt-0">
                          <div className="big_text">{customername}</div>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="newnewnew sec-tab mt-4">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="first"
                  >
                    <div className="row">
                      <div className="col-sm-12">
                        <Nav
                          variant="pills"
                          className="flex-row user_desk_tab vhjgvjh"
                        >
                          <Nav.Item>
                            <Nav.Link eventKey="first">Status</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="second">Script</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                      <div className="col-sm-12">
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <div className="black_bg_box progress-box nuiohiuh mt-4">
                              <div className="progress-box-inner">
                                {checktype === "0" ? (
                                  <>
                                    <div className="progress-item active">
                                      <div className="progress-item-icon">
                                        <div className="progress-item-icon-inner">
                                          <svg
                                            fill="none"
                                            height="64"
                                            viewBox="0 0 64 64"
                                            width="64"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g fill="#404650">
                                              <path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" />
                                              <path
                                                clip-rule="evenodd"
                                                d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z"
                                                fill-rule="evenodd"
                                              />
                                            </g>
                                          </svg>
                                        </div>
                                      </div>
                                      <div className="progress-item-content">
                                        <div className="progress-item-title">
                                          Club Fitting
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className={`progress-item ${checkActive(
                                        status,
                                        "prescription"
                                      )}`}
                                    >
                                      <div className="progress-item-icon">
                                        <div className="progress-item-icon-inner">
                                          <svg
                                            fill="none"
                                            height="64"
                                            viewBox="0 0 64 64"
                                            width="64"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g fill="#404650">
                                              <path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" />
                                              <g
                                                clip-rule="evenodd"
                                                fill-rule="evenodd"
                                              >
                                                <path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" />
                                                <path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" />
                                              </g>
                                            </g>
                                          </svg>
                                        </div>
                                      </div>
                                      <div className="progress-item-content">
                                        <div className="progress-item-title">
                                          Prescription
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <div
                                  className={`progress-item ${checkActive(
                                    status,
                                    "buildsheet"
                                  )}`}
                                >
                                  <div className="progress-item-icon">
                                    <div className="progress-item-icon-inner">
                                      <svg
                                        fill="none"
                                        height="64"
                                        viewBox="0 0 64 64"
                                        width="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g fill="#404650">
                                          <path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" />
                                          <path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" />
                                          <path
                                            clip-rule="evenodd"
                                            d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z"
                                            fill-rule="evenodd"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="progress-item-content">
                                    <div className="progress-item-title">
                                      Build Sheet
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`progress-item ${checkActive(
                                    status,
                                    "stagingstation"
                                  )}`}
                                >
                                  <div className="progress-item-icon">
                                    <div className="progress-item-icon-inner">
                                      <svg
                                        fill="none"
                                        height="64"
                                        viewBox="0 0 64 64"
                                        width="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          clip-rule="evenodd"
                                          fill="#404650"
                                          fill-rule="evenodd"
                                        >
                                          <path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-11 37c0-1.1046-.8954-2-2-2h-5c-1.1046 0-2 .8954-2 2s.8954 2 2 2h5c1.1046 0 2-.8954 2-2z" />
                                          <path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2 10c0-1.1046-.8954-2-2-2s-2 .8954-2 2v6.5c0 1.1046.8954 2 2 2h6.5c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-4.5z" />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="progress-item-content">
                                    <div className="progress-item-title">
                                      Staging
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`progress-item ${checkActive(
                                    status,
                                    "buildstation"
                                  )}`}
                                >
                                  <div className="progress-item-icon">
                                    <div className="progress-item-icon-inner">
                                      <svg
                                        fill="none"
                                        height="64"
                                        viewBox="0 0 64 64"
                                        width="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          clip-rule="evenodd"
                                          fill="#404650"
                                          fill-rule="evenodd"
                                        >
                                          <path d="m15.2752 2c-4.0003 0-7.61569 2.38397-9.19148 6.06081l-4.08372 9.52869v24.4105c0 6.6274 5.37258 12 12 12h14.7613c-1.1303-2.4315-1.7613-5.142-1.7613-8 0-10.4934 8.5066-19 19-19 2.858 0 5.5685.631 8 1.7613v-11.1718l-4.0837-9.52869c-1.5758-3.67684-5.1912-6.06081-9.1915-6.06081zm-5.5149 7.63648c.9455-2.2061 3.1147-3.63648 5.5149-3.63648h10.7248v10h-18.96692zm20.2397 6.36352v-10h10.7248c2.4002 0 4.5694 1.43038 5.5149 3.63649l2.7272 6.36351zm-13 25c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.1046 0-2-.8954-2-2s.8954-2 2-2z" />
                                          <path d="m30 46c0-8.8366 7.1634-16 16-16s16 7.1634 16 16-7.1634 16-16 16-16-7.1634-16-16zm24 0c0 1.1046-.8954 2-2 2h-4v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4h-4c-1.1046 0-2-.8954-2-2s.8954-2 2-2h4v-4c0-1.1046.8954-2 2-2s2 .8954 2 2v4h4c1.1046 0 2 .8954 2 2z" />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="progress-item-content">
                                    <div className="progress-item-title">
                                      Building
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`progress-item ${checkActive(
                                    status,
                                    "shipstation"
                                  )}`}
                                >
                                  <div className="progress-item-icon">
                                    <div className="progress-item-icon-inner">
                                      <svg
                                        fill="none"
                                        height="64"
                                        viewBox="0 0 64 64"
                                        width="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          clip-rule="evenodd"
                                          fill="#404650"
                                          fill-rule="evenodd"
                                        >
                                          <path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-15 34c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.10457 0-2-.8954-2-2s.89543-2 2-2z" />
                                          <path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2.5858 15.4142c.781.7811 2.0474.7811 2.8284 0 .7811-.781.7811-2.0474 0-2.8284l-4-4c-.781-.7811-2.0474-.7811-2.8284 0l-4 4c-.7811.781-.7811 2.0474 0 2.8284.781.7811 2.0474.7811 2.8284 0l.5858-.5858v7.1716c0 1.1046.8954 2 2 2s2-.8954 2-2v-7.1716z" />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="progress-item-content">
                                    <div className="progress-item-title">
                                      Shipping
                                    </div>
                                  </div>
                                </div>
                                {/* <div className={`progress-item ${checkActiveForComplete(status)}`}>
                                                <div className="progress-item-icon">
                                                    <div className="progress-item-icon-inner">
                                                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 512 512" width="512" data-name="Layer 1"><g clip-rule="evenodd" fill="#404650" fill-rule="evenodd"><path d="m258 404.93a141.07 141.07 0 0 1 236.79-103.61q1-72.31-1.2-144.62c-.8-33.12-19.5-66.37-50.83-82.8-16.1-8.51-32.78-16.7-49.65-24.46-66.66 21.56-144.73 50-223.47 85.21a44.44 44.44 0 0 0 -26.43 38.68c-1.23 38-1.61 77.22-1.11 116a5.32 5.32 0 0 1 -9.61 3.33q-12.5-16-24.42-31.64a4 4 0 0 0 -5.31-1.09q-9.27 5.52-18.21 10.89c-3.34 2-7.45-.67-7.47-4.78-.2-38.63.76-77.36 2.83-114.9.87-15.83 10.8-30.74 25.49-38 75.52-37.3 156.09-67.77 224.84-90.32-16-6.26-31.91-12-47.44-17.44a99.49 99.49 0 0 0 -64.62 0c-51.82 17.88-108.41 41.22-159.97 68.52-31.32 16.43-50 49.68-50.83 82.8q-3.06 99.3 0 198.6c.8 33.12 19.51 66.37 50.83 82.8 51.56 27.3 108.15 50.64 160 68.51a99.49 99.49 0 0 0 64.62 0q6.79-2.34 13.71-4.83a140.07 140.07 0 0 1 -38.54-96.85z" /><path d="m399.07 297.87a107.07 107.07 0 1 0 107.08 107.06 107.07 107.07 0 0 0 -107.08-107.06zm61.07 89.34-64.36 67.58a18.84 18.84 0 0 1 -13.58 5.86h-.09a18.91 18.91 0 0 1 -13.55-5.73l-34.15-35.18a18.88 18.88 0 0 1 27.1-26.3l20.49 21.09 50.81-53.36a18.88 18.88 0 0 1 27.35 26z" /></g></svg>
                                                    </div>
                                                </div>
                                                <div className="progress-item-content">
                                                    <div className="progress-item-title">Complete</div>
                                                </div>
                                            </div> */}
                              </div>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <div className=" tab-box-section my-4">
                              <div className="accordion-section">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item
                                    eventKey="0"
                                    className="results-accordion"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Bounce:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "bounce",
                                                      prescriptionNew?.bouncedropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          value={prescriptionNew?.bounce}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          rows="3"
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="1"
                                    className="results-accordion black"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Lie Angle:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "lieAngle",
                                                      prescriptionNew?.lieagedropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          value={prescriptionNew?.lieage}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          rows="3"
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="2"
                                    className="results-accordion blue"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Shaft Weight:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "shaftWeight",
                                                      prescriptionNew?.shaftweightdropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          rows="3"
                                          value={prescriptionNew?.shaftweight}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="3"
                                    className="results-accordion pink"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Shaft Flex:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "shaftFlex",
                                                      prescriptionNew?.shaftflexdropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          rows="3"
                                          value={prescriptionNew?.shaftflex}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="5"
                                    className="results-accordion red"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Grip Size:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "gripSize",
                                                      prescriptionNew?.gripSizedropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          rows="3"
                                          value={prescriptionNew?.gripSize}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="6"
                                    className="results-accordion orange"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Club Length:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "clubLength",
                                                      prescriptionNew?.clubLengthdropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          rows="3"
                                          value={prescriptionNew?.clubLength}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="7"
                                    className="results-accordion green"
                                  >
                                    <div className="gs_b p-0 club-fitting-card  accordion-item">
                                      <div
                                        className="accordion_card_view"
                                        id="lesson_card_1"
                                      >
                                        <Accordion.Header>
                                          <div className="gab_title">
                                            <div className="gab_text text-left">
                                              <h5>
                                                <span className="color"></span>
                                                <div className="d-flex align-items-center gap-1">
                                                  Swing Weight:{" "}
                                                  <div className="light-text">
                                                    {getselectbounce(
                                                      "swingWeight",
                                                      prescriptionNew?.swingWeightdropdownselect
                                                    )}
                                                  </div>
                                                </div>
                                              </h5>
                                            </div>
                                            <div className="collapsed">
                                              <div className="gab_icon ">
                                                <FaAngleUp />
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                      </div>
                                      <Accordion.Body className="results-accordion-body">
                                        <textarea
                                          className="dashboard-text-area"
                                          rows="3"
                                          value={prescriptionNew?.swingWeight}
                                          style={{
                                            color: "#ffffff",
                                            pointerEvents: "none",
                                          }}
                                          disabled
                                          placeholder="Enter your script here"
                                        ></textarea>
                                      </Accordion.Body>
                                    </div>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            </div>
                            <div className="Optimal_Heads">
                              {optimalHeads === 1 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill="#aee750"
                                        strokeWidth="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option1?.make
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {makedata &&
                                          makedata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option1?.model
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {head1 &&
                                          head1.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                              {optimalHeads === 2 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill="#aee750"
                                        strokeWidth="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option2?.make
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalHeads",
                                            2,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {makedata &&
                                          makedata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option2?.model
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {head2 &&
                                          head2.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                              {optimalHeads === 3 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill="#aee750"
                                        strokeWidth="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option3?.make
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalHeads",
                                            3,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {makedata &&
                                          makedata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalHeadsobject?.option3?.model
                                        }
                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {head3 &&
                                          head3.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="Optimal_Shafts">
                              {optimalShafts === 1 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalShafts === 1
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option1?.make ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalShafts",
                                            1,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {shaftdata &&
                                          shaftdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option1?.model ||
                                          ""
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Shaft1 &&
                                          Shaft1.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}

                              {optimalShafts === 2 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2 "
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalShafts === 2
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option2?.make ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalShafts",
                                            2,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {shaftdata &&
                                          shaftdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option2?.model ||
                                          ""
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Shaft2 &&
                                          Shaft2.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}

                              {optimalShafts === 3 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalShafts === 3
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option3?.make ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalShafts",
                                            3,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {shaftdata &&
                                          shaftdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalShaftsobject?.option3?.model ||
                                          ""
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Shaft3 &&
                                          Shaft3.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="Optimal_Grips">
                              {optimalGrips === 1 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalGrips === 1
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option1?.make
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalGrips",
                                            1,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {gripdata &&
                                          gripdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option1?.model
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Grip1 &&
                                          Grip1.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}

                              {optimalGrips === 2 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalGrips === 2
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option2?.make
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalGrips",
                                            2,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {gripdata &&
                                          gripdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option2?.model
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Grip2 &&
                                          Grip2.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}

                              {optimalGrips === 3 && (
                                <>
                                  <div className="row mb-3 d-flex align-items-center">
                                    <label
                                      className="col-2 col-sm-2"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "-30px",
                                      }}
                                    >
                                      <svg
                                        stroke="currentColor"
                                        fill={`${optimalGrips === 3
                                          ? "#aee750"
                                          : "#404650"
                                          }`}
                                        stroke-width="0"
                                        viewBox="0 0 576 512"
                                        height="37"
                                        width="37"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                      </svg>
                                    </label>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option3?.make
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "optimalGrips",
                                            3,
                                            "make",
                                            e.target.value
                                          )
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Make
                                        </option>
                                        {gripdata &&
                                          gripdata.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.brand_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-5 col-sm-5 mb-3">
                                      <select
                                        disabled
                                        value={
                                          optimalGripsobject?.option3?.model
                                        }
                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                        aria-label="Default select example"
                                      >
                                        <option value="" disabled>
                                          Model
                                        </option>
                                        {Grip3 &&
                                          Grip3.map((item) => (
                                            <option
                                              value={item._id}
                                              key={item._id}
                                            >
                                              {item.ModelName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </div>
                    </div>
                  </Tab.Container>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div className="dashboard-container d-flex dashboard_light project_dashboard_sec build_box_dashboard_sec">
            <div className="main-container">
              <div className="main-page-body-content">
                <div className="main-page-body-content-body">
                  <div className="main-page-body-content-body-container">
                    <div className="container-fluid">
                      <div className="sec-dashboard-header-title">
                        <div className="sec-header-new">
                          <button
                            type="button"
                            className="btn-header-transparent"
                          >
                            <div className="border_box_view">
                              <div className="border_box_view_inner">
                                <div className="box_icon">
                                  <svg
                                    viewBox="-42 0 512 512.002"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#99ea24"
                                  >
                                    <path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                                    <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                                  </svg>
                                </div>
                                <div className="box_text_content">
                                  <div className="big_text">
                                    {userdata.firstname +
                                      " " +
                                      userdata.lastname}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className="dashboard-sec">
                        <div className="row">
                          <div className="col-lg-6 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 small-hide">
                            <>
                              {filteredData.length === 0 ? (
                                <div className="black_bg_box mt-0">
                                  <div className="no-data-img">
                                    <img
                                      src={require("../assets/images/logo_text.png")}
                                      alt=""
                                    />
                                  </div>
                                  <div className="no-data-text">
                                    <h3>No projects to show</h3>
                                  </div>
                                </div>
                              ) : (
                                filteredData &&
                                filteredData.map((item, i) => {
                                  return (
                                    <div className="black_bg_box mt-0">
                                      {item?.submitted_status === 0 ? (
                                        <>
                                          <div className="black_bg_box_inner">
                                            <div className="left_box_content">
                                              <div className="list_border_boxs project-list-box">
                                                <div className="border_box_view">
                                                  <div className="border_box_view_inner">
                                                    <div className="box_icon">
                                                      {/* {getsvgicon(item.current_stage)} */}
                                                      <svg
                                                        viewBox="-42 0 512 512.002"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="#99ea24"
                                                      >
                                                        <path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                                                        <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                                                      </svg>
                                                    </div>
                                                    <div className="box_text_content">
                                                      <div className="little_text">
                                                        Customer:
                                                      </div>
                                                      <div className="big_text">
                                                        {item &&
                                                          item.firstname +
                                                          " " +
                                                          item.lastname}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="border_box_view">
                                                  <div className="border_box_view_inner">
                                                    <div className="box_icon">
                                                      <FaCalendarAlt />
                                                    </div>
                                                    <div className="box_text_content">
                                                      {/* <div className="little_text">Start Date:</div>
                                                                                                                <div className="big_text">{item && formatDate(item.createdAt)}</div> */}
                                                      <div className="little_text">
                                                        Status:
                                                      </div>
                                                      <div className="big_text">
                                                        Open Fitting
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="right_box_content">
                                              <div className="box_btn">
                                                {item.studio_fitting === 0 ? (
                                                  <Link
                                                    to={`/remote_fittings_camera/${item.user_id}`}
                                                  >
                                                    <button className="btn customer_btn_view">
                                                      <IoMdEye />
                                                    </button>
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    to={`/remote_fittings_studio/${item.user_id}`}
                                                  >
                                                    <button className="btn customer_btn_view">
                                                      <IoMdEye />
                                                    </button>
                                                  </Link>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="black_bg_box_inner">
                                            <div className="left_box_content">
                                              <div className="list_border_boxs project-list-box">
                                                <div className="border_box_view">
                                                  <div className="border_box_view_inner">
                                                    <div className="box_icon">
                                                      {getsvgicon(
                                                        item.current_stage
                                                      )}
                                                    </div>
                                                    <div className="box_text_content">
                                                      <div className="little_text">
                                                        Status:
                                                      </div>
                                                      <div className="big_text">
                                                        {item &&
                                                          getcurrentstage(
                                                            item?.current_stage
                                                          )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="border_box_view">
                                                  <div className="border_box_view_inner">
                                                    <div className="box_icon">
                                                      <FaCalendarAlt />
                                                    </div>
                                                    <div className="box_text_content">
                                                      <div className="little_text">
                                                        Start Date:
                                                      </div>
                                                      <div className="big_text">
                                                        {item &&
                                                          formatDate(
                                                            item.createdAt
                                                          )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="right_box_content">
                                              <div className="box_btn">
                                                <button
                                                  className="btn customer_btn_view"
                                                  onClick={(e) => {
                                                    // showstagespopup();
                                                    setStatus(item.category);
                                                    setCustomername(
                                                      item.firstname +
                                                      " " +
                                                      item.lastname
                                                    );
                                                    setChecktype(item.type);
                                                    // setRemortFittingFormData(item);
                                                    getremoteInquiryapifunc(
                                                      item?._id
                                                    );
                                                  }}
                                                >
                                                  <IoMdEye />
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  );
                                })
                              )}
                            </>
                          </div>
                          <div
                            className={`col-lg-6 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1  right_fix_sec`}
                          >
                            <div className="fix_sec_view container-fluid ps-0">
                              <div className="btn-box-section d-block small-hide mt-0">
                                <Link to="/fitter-customer">
                                  <button className="btn btn-primary btn-create">
                                    Start Fitting
                                  </button>
                                </Link>
                              </div>
                              <div className="tab-container tab-club-fitting">
                                <div className="small-hide">
                                  <Tabs
                                    defaultActiveKey="Profile"
                                    id="uncontrolled-tab-example"
                                    className="club-fitting-tab tab_new_customer two-tab-design"
                                  >
                                    <Tab eventKey="Profile" title="Profile">
                                      <div className="tab-form-header my-4">
                                        <h3 className="text-white">
                                          My Profile
                                        </h3>

                                        {edittrue ? (
                                          apicall ? (
                                            <button className="btn btn-save">
                                              <Spinner
                                                animation="border"
                                                className="border-black"
                                              />
                                            </button>
                                          ) : (
                                            <div className="sec-btn-group d-flex justify-content-end">
                                              <button
                                                className="btn tab_form_btn save_btn"
                                                onClick={handleUpdateSubmit}
                                              >
                                                Save
                                              </button>
                                            </div>
                                          )
                                        ) : (
                                          <button
                                            className="btn tab_form_btn"
                                            onClick={handleedittrue}
                                            style={{
                                              backgroundColor: "#1e1f25",
                                              height: "55px",
                                              border: "none",
                                            }}
                                          >
                                            Edit
                                          </button>
                                        )}
                                      </div>
                                      <div className="tab-box-section">
                                        <Form noValidate validated={validated}>
                                          <div className="profile-images-container position-relative">
                                            {/* Cover Image Input */}
                                            <div className="cover-image-container">
                                              <input
                                                type="file"
                                                id="coverImageInput"
                                                accept="image/*"
                                                className="image-input"
                                                onChange={
                                                  handleCoverImageChange
                                                }
                                                style={{
                                                  opacity: 0,
                                                  position: "absolute",
                                                  height: "15rem",
                                                  width: "100%",
                                                  cursor: edittrue
                                                    ? "pointer"
                                                    : "default",
                                                  zIndex: 2,
                                                  pointerEvents: edittrue
                                                    ? "auto"
                                                    : "none",
                                                }}
                                                disabled={!edittrue}
                                              />
                                              <label
                                                htmlFor="coverImageInput"
                                                className="profile-image-container text-center"
                                                style={{
                                                  backgroundColor: "#41464f",
                                                  height: "15rem",
                                                  borderRadius: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: edittrue
                                                    ? "pointer"
                                                    : "default",
                                                  position: "relative",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                {/* Cover image display */}
                                                {coverImage &&
                                                  typeof coverImage ===
                                                  "object" ? (
                                                  <img
                                                    src={URL.createObjectURL(
                                                      coverImage
                                                    )}
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                ) : databasecoverimage ? (
                                                  <img
                                                    src={
                                                      API_URL +
                                                      "cover_images/" +
                                                      databasecoverimage
                                                    }
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={`default-images/default_cover_image.jpg`}
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                )}

                                                {/* Edit mode overlay with + icon */}
                                                {edittrue && (
                                                  <div
                                                    className="edit-overlay"
                                                    style={{
                                                      position: "absolute",
                                                      top: 0,
                                                      left: 0,
                                                      width: "100%",
                                                      height: "100%",
                                                      backgroundColor:
                                                        "rgba(65, 70, 79, 0.7)", // semi-transparent overlay
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      borderRadius: "10px",
                                                    }}
                                                  >
                                                    <div
                                                      className="plus-icon"
                                                      style={{
                                                        color: "#fff",
                                                        fontSize: "5rem",
                                                      }}
                                                    >
                                                      +
                                                    </div>
                                                  </div>
                                                )}

                                                {/* Default icon when no image */}
                                                {/* {!coverImage && !edittrue && (
                                                <div>
                                                  <i className="fa fa-image mb-2" style={{ fontSize: "2rem", color: "#fff" }}></i>
                                                </div>
                                              )} */}
                                              </label>
                                            </div>

                                            {/* Profile Image Input */}
                                            <div
                                              className="profile-image-wrapper mx-auto d-flex align-items-center justify-content-center"
                                              style={{
                                                transform: "translateY(-50%)",
                                                zIndex: 3,
                                                position: "relative",
                                              }}
                                            >
                                              <div
                                                className="profile-image rounded-circle"
                                                style={{
                                                  width: "120px",
                                                  height: "120px",
                                                  border: "10px solid #1e1f25",
                                                  position: "relative",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                <input
                                                  type="file"
                                                  id="profileImageInput"
                                                  accept="image/*"
                                                  className="image-input"
                                                  onChange={(e) =>
                                                    handleProfileImageChange(e)
                                                  }
                                                  style={{
                                                    opacity: 0,
                                                    position: "absolute",
                                                    height: "100%",
                                                    width: "100%",
                                                    cursor: edittrue
                                                      ? "pointer"
                                                      : "default",
                                                    zIndex: 2,
                                                    pointerEvents: edittrue
                                                      ? "auto"
                                                      : "none", // Disable interaction when not in edit mode
                                                  }}
                                                  disabled={!edittrue}
                                                />
                                                <label
                                                  htmlFor="profileImageInput"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                    height: "100%",
                                                    cursor: edittrue
                                                      ? "pointer"
                                                      : "default",
                                                    position: "relative",
                                                  }}
                                                >
                                                  {/* Profile image display */}
                                                  {profileImage ? (
                                                    <img
                                                      src={URL.createObjectURL(
                                                        profileImage
                                                      )}
                                                      alt="Profile"
                                                      className="img-fluid rounded-circle"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "100%",
                                                        objectFit: "cover",
                                                      }}
                                                    />
                                                  ) : databaseimage ? (
                                                    <img
                                                      src={
                                                        API_URL +
                                                        "images/" +
                                                        databaseimage
                                                      }
                                                      alt="Profile"
                                                      className="img-fluid rounded-circle"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "100%",
                                                        objectFit: "cover",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={`default-images/default_user_image.jpg`}
                                                      alt="Cover Preview"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "10px",
                                                      }}
                                                    />)}

                                                  {/* Edit mode overlay with + icon */}
                                                  {edittrue && (
                                                    <div
                                                      className="edit-overlay"
                                                      style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.5)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius: "50%",
                                                      }}
                                                    >
                                                      <div
                                                        className="plus-icon"
                                                        style={{
                                                          color: "#fff",
                                                          fontSize: "3rem",
                                                        }}
                                                      >
                                                        +
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* Default icon when no image and not in edit mode */}
                                                  {!profileImage &&
                                                    !edittrue && <></>}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row gx-2" style={{ marginTop: "-40px" }}>
                                            <fieldset>
                                              <div className="row">
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom01"
                                                >
                                                  <input
                                                    type="text"
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="First name"
                                                    required
                                                    disabled={!edittrue}
                                                    value={userdata.firstname}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    name={"firstname"}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter a first name.
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <input
                                                    type="text"
                                                    name="lastname"
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="Last name"
                                                    required
                                                    value={userdata.lastname}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    disabled={!edittrue}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter a last name.
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom03"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  name={"business_name"}
                                                  required
                                                  placeholder="Business Name"
                                                  disabled={!edittrue}
                                                  value={userdata.business_name}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please enter a business name.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom03"
                                              >
                                                <input
                                                  type="tel"
                                                  className="form-control dashboard-input-box-3"
                                                  name={"phone"}
                                                  required
                                                  placeholder="Phone Number"
                                                  disabled={!edittrue}
                                                  value={userdata.phone}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please enter a 8-digit phone
                                                  number.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="email"
                                                  className="form-control dashboard-input-box-3"
                                                  name="email"
                                                  placeholder="Email"
                                                  disabled={!edittrue}
                                                  value={userdata.email}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a email.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  disabled={!edittrue}
                                                  value={userdata.website_url}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                  name="website_url"
                                                  placeholder="Website URL..."
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a website.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div className="row">
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <select
                                                    name="country"
                                                    disabled={!edittrue}
                                                    value={userdata.country}
                                                    onChange={(e) => {
                                                      dataChange(e);
                                                      getallstatefunc(
                                                        e.target.value
                                                      );
                                                    }}
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    <option value={0}>
                                                      Country
                                                    </option>
                                                    {countrylist &&
                                                      countrylist.map(
                                                        (item) => (
                                                          <option
                                                            value={item._id}
                                                            key={item._id}
                                                          >
                                                            {item.name}
                                                          </option>
                                                        )
                                                      )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please choose country
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <select
                                                    name="state"
                                                    disabled={!edittrue}
                                                    value={userdata.state}
                                                    onChange={(e) => {
                                                      dataChange(e);
                                                      getallcityfunc(
                                                        e.target.value
                                                      );
                                                    }}
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    {/* <option value={0}>
                                                      State
                                                    </option>
                                                    {statelist &&
                                                      statelist.map((item) => (
                                                        <option
                                                          value={item._id}
                                                          key={item._id}
                                                        >
                                                          {item.name}
                                                        </option>
                                                      ))} */}
                                                    {stateLoading ? (
                                                      <option disabled>Loading...</option>
                                                    ) : (
                                                      <>
                                                        <option value={0}>State</option>
                                                        {statelist &&
                                                          statelist.map((item) => (
                                                            <option value={item._id} key={item._id}>
                                                              {item.name}
                                                            </option>
                                                          ))}
                                                      </>
                                                    )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter State
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  disabled={!edittrue}
                                                  value={userdata.address}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                  name="address"
                                                  placeholder="Street Address, Apt. #"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a street
                                                  address.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div className="row">
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom01"
                                                >
                                                  <select
                                                    name="city"
                                                    disabled={!edittrue}
                                                    value={userdata.city}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    {/* <option value={0}>
                                                      City/Town
                                                    </option>
                                                    {citylist &&
                                                      citylist.map((item) => (
                                                        <option
                                                          value={item._id}
                                                          key={item._id}
                                                        >
                                                          {item.name}
                                                        </option>
                                                      ))} */}
                                                    {cityLoading ? (
                                                      <option disabled>Loading...</option>
                                                    ) : (
                                                      <>
                                                        <option value={0}>City/Town</option>
                                                        {citylist &&
                                                          citylist.map((item) => (
                                                            <option value={item._id} key={item._id}>
                                                              {item.name}
                                                            </option>
                                                          ))}
                                                      </>
                                                    )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter City
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-6 form-group "
                                                  controlid="validationCustom02"
                                                >
                                                  <input
                                                    type="text"
                                                    name="zip"
                                                    disabled={!edittrue}
                                                    value={userdata.zip}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="Zip Code"
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter Zip Code
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              {/* <div className="row">
                                                <div
                                                  className="col-md-12 form-group mb-0"
                                                  controlid="validationCustom015"
                                                >
                                                  <textarea
                                                    className="dashboard-text-area"
                                                    name="bio"
                                                    disabled={!edittrue}
                                                    value={userdata.bio}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    rows="3"
                                                    placeholder="Bio..."
                                                  ></textarea>
                                                </div>
                                              </div> */}
                                              <div className="row">
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom04"
                                                  style={{ position: 'relative' }}
                                                >
                                                  <input
                                                    type="file"
                                                    name="zip"
                                                    accept="video/*"
                                                    onChange={handleBioVideo}
                                                    disabled={!edittrue}
                                                    className="form-control dashboard-input-box-3"
                                                    style={{
                                                      backgroundColor: "rgb(65 70 79)",
                                                      borderRadius: "10px",
                                                      cursor: edittrue ? "pointer" : "not-allowed",
                                                      color: "transparent", // hides default text
                                                      textIndent: "-9999px", // pushes text offscreen
                                                    }}
                                                  />
                                                  <div
                                                    style={{
                                                      transform: "translateY(-125%)",
                                                      padding: "10px 25px",
                                                      color: "#ffffff",
                                                      display: "flex",
                                                      fontSize: "18.5px",
                                                      fontWeight: "normal",
                                                      alignItems: "center",
                                                      justifyContent: "space-between",
                                                      pointerEvents: "none", // allows clicking input below
                                                    }}
                                                  >
                                                    <span style={{ color: "#ffffff" }}>Upload Bio Video</span>
                                                    <FiUpload size={24} strokeWidth={3} />
                                                  </div>
                                                </div>
                                              </div>


                                              {(bioVideo || databasebiovideo) && (
                                                <div className="row" style={{ marginTop: "-3rem" }}>
                                                  <div
                                                    className="col-md-12 form-group mb-0"
                                                    controlid="validationCustom015"
                                                  >
                                                    <div
                                                      className="video-container1"
                                                      style={{
                                                        backgroundSize: "cover",
                                                        backgroundPosition:
                                                          "center",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        borderRadius: "15px",
                                                      }}
                                                    >
                                                      <video
                                                        key={bioVideo ? bioVideo.name : databasebiovideo}
                                                        playsInline
                                                        autoPlay={false}
                                                        controls
                                                        preload="metadata"
                                                        style={{
                                                          width: "100%",
                                                          height: "100%",
                                                          borderRadius: "10px",
                                                        }}
                                                        controlsList="nodownload"
                                                      >
                                                        <source
                                                          src={
                                                            bioVideo
                                                              ? URL.createObjectURL(bioVideo)
                                                              : API_URL + "attachment/" + databasebiovideo + "#t=0.1"
                                                          }
                                                          type="video/mp4"
                                                        />
                                                        Your browser does not
                                                        support HTML5 video.
                                                      </video>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </fieldset>
                                          </div>
                                        </Form>
                                      </div>
                                    </Tab>
                                    <Tab eventKey="Posts" title="Posts">
                                      <div className="jhcgchcvuvu">
                                        <>
                                          <div className="tab-form-header my-4">
                                            <h3 className="text-white">
                                              My Posts
                                            </h3>

                                            {activepost ? (
                                              <div className="sec-btn-group d-flex justify-content-end">
                                                <button
                                                  className="btn tab_form_btn"
                                                  disabled
                                                  style={{
                                                    backgroundColor: "#1e1f25",
                                                    height: "55px",
                                                    border: "none",
                                                  }}
                                                >
                                                  create
                                                </button>
                                              </div>
                                            ) : (
                                              <button
                                                className="btn tab_form_btn"
                                                onClick={handleactivepost}
                                                style={{
                                                  backgroundColor: "#1e1f25",
                                                  height: "55px",
                                                  border: "none",
                                                }}
                                              >
                                                create
                                              </button>
                                            )}
                                          </div>
                                          {activepost && (
                                            <div className="black_bg_box mt-0 ">
                                              <Form
                                                noValidate
                                                validated={validated}
                                                onSubmit={handleSubmit}
                                              >
                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom011"
                                                  >
                                                    <div className="custom-file-upload">
                                                      <input
                                                        name="image"
                                                        type="file"
                                                        required
                                                        ref={fileInputRef}
                                                        className="file-input-hidden"
                                                        onChange={(e) => {
                                                          const file =
                                                            e.target.files[0];
                                                          if (file) {
                                                            setimage(file);
                                                            setImagePreview(
                                                              URL.createObjectURL(
                                                                file
                                                              )
                                                            );
                                                          }
                                                        }}
                                                      />
                                                      <div className="file-upload-placeholder">
                                                        {imagePreview ? (
                                                          <img
                                                            src={imagePreview}
                                                            alt="Preview"
                                                            style={{
                                                              maxHeight: "100%",
                                                              maxWidth: "100%",
                                                            }}
                                                          />
                                                        ) : (
                                                          <FiImage
                                                            size={60}
                                                            color="#ffffff"
                                                          />
                                                        )}
                                                        {/* <FiImage size={60} color="#ffffff" /> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom012"
                                                  >
                                                    <input
                                                      name="title"
                                                      type="text"
                                                      required
                                                      className="form-control dashboard-input-box-3"
                                                      value={title}
                                                      onChange={(e) =>
                                                        setTitle(e.target.value)
                                                      }
                                                      placeholder="Title your post here...."
                                                    />
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom013"
                                                  >
                                                    <textarea
                                                      name="descripation"
                                                      className="dashboard-text-area"
                                                      value={descripation}
                                                      onChange={(e) =>
                                                        setDescripation(
                                                          e.target.value
                                                        )
                                                      }
                                                      rows="5"
                                                      placeholder="Write a description for your post..."
                                                      required
                                                    ></textarea>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div className="col-sm-6 col-12 form-group mb-0">
                                                    {postsloader ? (
                                                      <button
                                                        className="btn btn-create"
                                                        disabled
                                                      >
                                                        Saving....
                                                      </button>
                                                    ) : (
                                                      <button
                                                        className="btn btn-create"
                                                        type="submit"
                                                      >
                                                        Save Post
                                                      </button>
                                                    )}
                                                  </div>
                                                  <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                    <button
                                                      className="btn btn-create ubuyuy"
                                                      onClick={removepostdata}
                                                      style={{
                                                        backgroundColor:
                                                          "#f34c12 !important",
                                                      }}
                                                    >
                                                      Remove Post
                                                    </button>
                                                  </div>
                                                </div>

                                                <style jsx>{`
                                                  @media screen and (max-width: 575px) {
                                                    .jhcgchcvuvu .eferfefef {
                                                      margin-top: 10px;
                                                    }
                                                  }
                                                  @media screen and (max-width: 450px) {
                                                    .jhcgchcvuvu .btn-create {
                                                      font-size: 16px;
                                                    }
                                                  }
                                                  .jhcgchcvuvu
                                                    .btn-create.ubuyuy {
                                                    background-color: #f34c12 !important;
                                                    color: #ffffff !important;
                                                  }
                                                  .jhcgchcvuvu
                                                    .btn-create.vergrgre {
                                                    background-color: #404650 !important;
                                                    color: #ffffff !important;
                                                  }
                                                  .jhcgchcvuvu .btn-create,
                                                  .jhcgchcvuvu .ubuyuy {
                                                    font-weight: 600 !important;
                                                  }
                                                  .jhcgchcvuvu
                                                    .custom-file-upload {
                                                    position: relative;
                                                    height: 15rem;
                                                    border-radius: 15px;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    cursor: pointer;
                                                    overflow: hidden;
                                                    background-color: #41464f;
                                                    transition: all 0.3s ease;
                                                  }

                                                  .jhcgchcvuvu
                                                    .custom-file-upload:hover {
                                                    border-color: #666;
                                                    background-color: #f0f0f0;
                                                  }

                                                  .jhcgchcvuvu
                                                    .file-input-hidden {
                                                    position: absolute;
                                                    top: 0;
                                                    left: 0;
                                                    width: 100%;
                                                    height: 100%;
                                                    opacity: 0;
                                                    cursor: pointer;
                                                    z-index: 2;
                                                  }

                                                  .jhcgchcvuvu
                                                    .file-upload-placeholder {
                                                    display: flex;
                                                    flex-direction: column;
                                                    align-items: center;
                                                    justify-content: center;
                                                    text-align: center;
                                                    color: #666;
                                                  }

                                                  .jhcgchcvuvu .upload-icon {
                                                    font-size: 2rem;
                                                    margin-bottom: 0.5rem;
                                                    color: #666;
                                                  }
                                                `}</style>
                                              </Form>
                                            </div>
                                          )}

                                          {postdata.length === 0 ? (
                                            <div className="black_bg_box mt-0">
                                              <div className="no-data-img">
                                                <img
                                                  src={require("../assets/images/logo_text.png")}
                                                  alt=""
                                                />
                                              </div>
                                              <div className="no-data-text">
                                                <h3>No posts to show</h3>
                                              </div>
                                            </div>
                                          ) : (
                                            postdata &&
                                            postdata.map((item, i) => {
                                              return (
                                                <div
                                                  className="black_bg_box mt-0"
                                                  key={i}
                                                >
                                                  {/* Image */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <input
                                                          type="file"
                                                          onChange={
                                                            handleImageChange
                                                          }
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                          }}
                                                          className="form-control"
                                                        />
                                                      ) : (
                                                        <div
                                                          className="profile-image-container text-center"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            height: "20rem",
                                                            borderRadius:
                                                              "10px",
                                                            position:
                                                              "relative",
                                                            display: "flex", alignItems: "center", justifyContent: "center"
                                                          }}
                                                        >
                                                          <img
                                                            src={
                                                              API_URL +
                                                              `posts/` +
                                                              item?.post_image
                                                            }
                                                            alt="Post"
                                                            style={{
                                                              maxWidth: "100%",
                                                              maxHeight: "100%",
                                                              objectFit:
                                                                "contain",
                                                              borderRadius: "10px"
                                                            }}
                                                          />
                                                          <div
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{
                                                              width: "2rem",
                                                              height: "2rem",
                                                              borderRadius:
                                                                "5px",
                                                              backgroundColor:
                                                                "#ffffff",
                                                              position:
                                                                "absolute",
                                                              bottom: "10px",
                                                              right: "10px",
                                                              transform: "",
                                                            }}
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              setSelectedImage(API_URL + "posts/" + item?.post_image);
                                                            }}
                                                          >
                                                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 512 512" width="512" data-name="Layer 1" fill=""><path d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z" fill-rule="evenodd" fill="#99ea24" /></svg>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Title */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <input
                                                          type="text"
                                                          name="title"
                                                          value={
                                                            editedPost.title ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          className="form-control"
                                                          placeholder="Enter title"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                            color: "#ffffff"
                                                          }}
                                                        />
                                                      ) : (
                                                        <p
                                                          className="text-white mb-2"
                                                          style={{
                                                            fontSize: "22px",
                                                          }}
                                                        >
                                                          {item.title}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Description */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <textarea
                                                          name="descripation"
                                                          value={
                                                            editedPost.descripation ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          className="form-control"
                                                          rows="3"
                                                          placeholder="Enter description"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                            color: "#ffffff"
                                                          }}
                                                        ></textarea>
                                                      ) : (
                                                        <p
                                                          style={{
                                                            // width: "337.5px",
                                                            // height: "59.5px",

                                                            fontSize: "16px",
                                                            fontWeight: 500,
                                                            fontStyle: "normal",
                                                            lineHeight: 2,
                                                            letterSpacing:
                                                              "normal",
                                                            textAlign: "left",
                                                            color: "#ffffff",
                                                          }}
                                                          className="mb-2"
                                                        >
                                                          {item.descripation}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Action Buttons */}
                                                  <div className="row">
                                                    {/* <div className="col-sm-6 col-12 form-group mb-0"> */}
                                                    {editIndex === i ? (
                                                      <>
                                                        <div className="col-sm-6 col-12 form-group mb-0">
                                                          <button
                                                            className="btn btn-create"
                                                            onClick={handleSave}
                                                            disabled={
                                                              UpdatePostLoader
                                                            }
                                                          >
                                                            {UpdatePostLoader
                                                              ? "editing..."
                                                              : "Edit Post"}
                                                          </button>
                                                        </div>

                                                        <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                          <button
                                                            className="btn btn-create ubuyuy"
                                                            onClick={handleCancel}
                                                          >
                                                            Removing Post
                                                          </button>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <div className="col-sm-6 col-12 form-group mb-0">
                                                          <button
                                                            className="btn btn-create vergrgre"
                                                            onClick={() =>
                                                              handleEditClick(
                                                                i,
                                                                item
                                                              )
                                                            }
                                                          >
                                                            Edit Post
                                                          </button>
                                                        </div>

                                                        <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                          <button
                                                            className="btn btn-create ubuyuy"
                                                            onClick={() => {
                                                              handleShowremovepostpop();
                                                              setPostId(item?._id)
                                                            }}
                                                          >
                                                            Remove Post
                                                          </button>
                                                        </div>
                                                      </>
                                                    )}
                                                    {/* </div> */}
                                                    {/* <div className="col-sm-6 col-12 eferfefef form-group mb-0">

                                                    </div> */}
                                                  </div>

                                                  {selectedImage && (
                                                    <div
                                                      className="modal-overlay"
                                                      style={{
                                                        position: "fixed",
                                                        top: 0, left: 0, right: 0, bottom: 0,
                                                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        zIndex: 9999
                                                      }}
                                                      onClick={() => setSelectedImage(null)} // click to close
                                                    >
                                                      <img
                                                        src={selectedImage}
                                                        alt="Zoomed"
                                                        style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }}
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            })
                                          )}
                                        </>
                                      </div>
                                    </Tab>
                                  </Tabs>
                                </div>
                                <div className="small-show">
                                  <Tabs
                                    defaultActiveKey="Profile"
                                    id="uncontrolled-tab-example"
                                    className="club-fitting-tab tab_new_customer two-tab-design "
                                  >
                                    <Tab eventKey="Profile" title="Profile">
                                      <div className="tab-form-header design_hide_desktop my-4">
                                        <h3 className="text-white">
                                          My Profile
                                        </h3>

                                        {edittrue ? (
                                          apicall ? (
                                            <button className="btn btn-save">
                                              <Spinner
                                                animation="border"
                                                className="border-black"
                                              />
                                            </button>
                                          ) : (
                                            <div className="sec-btn-group d-flex justify-content-end">
                                              <button
                                                className="btn tab_form_btn save_btn"
                                                onClick={handleUpdateSubmit}
                                              >
                                                Save
                                              </button>
                                            </div>
                                          )
                                        ) : (
                                          <button
                                            className="btn tab_form_btn"
                                            onClick={handleedittrue}
                                            style={{
                                              backgroundColor: "#1e1f25",
                                              height: "55px",
                                              border: "none",
                                            }}
                                          >
                                            Edit
                                          </button>
                                        )}
                                      </div>
                                      <div className="tab-box-section design_hide_desktop">
                                        <Form noValidate validated={validated}>
                                          <div className="profile-images-container position-relative">
                                            {/* Cover Image Input */}
                                            <div className="cover-image-container">
                                              <input
                                                type="file"
                                                id="coverImageInput"
                                                accept="image/*"
                                                className="image-input"
                                                onChange={
                                                  handleCoverImageChange
                                                }
                                                style={{
                                                  opacity: 0,
                                                  position: "absolute",
                                                  height: "15rem",
                                                  width: "100%",
                                                  cursor: edittrue
                                                    ? "pointer"
                                                    : "default",
                                                  zIndex: 2,
                                                  pointerEvents: edittrue
                                                    ? "auto"
                                                    : "none",
                                                }}
                                                disabled={!edittrue}
                                              />
                                              <label
                                                htmlFor="coverImageInput"
                                                className="profile-image-container text-center"
                                                style={{
                                                  backgroundColor: "#41464f",
                                                  height: "15rem",
                                                  borderRadius: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: edittrue
                                                    ? "pointer"
                                                    : "default",
                                                  position: "relative",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                {/* Cover image display */}
                                                {coverImage &&
                                                  typeof coverImage ===
                                                  "object" ? (
                                                  <img
                                                    src={URL.createObjectURL(
                                                      coverImage
                                                    )}
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                ) : databasecoverimage ? (
                                                  <img
                                                    src={
                                                      API_URL +
                                                      "cover_images/" +
                                                      databasecoverimage
                                                    }
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                ) : (<img
                                                  src={`default-images/default_cover_image.jpg`}
                                                  alt="Cover Preview"
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "10px",
                                                  }}
                                                />)}

                                                {/* Edit mode overlay with + icon */}
                                                {edittrue && (
                                                  <div
                                                    className="edit-overlay"
                                                    style={{
                                                      position: "absolute",
                                                      top: 0,
                                                      left: 0,
                                                      width: "100%",
                                                      height: "100%",
                                                      backgroundColor:
                                                        "rgba(65, 70, 79, 0.7)", // semi-transparent overlay
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      borderRadius: "10px",
                                                    }}
                                                  >
                                                    <div
                                                      className="plus-icon"
                                                      style={{
                                                        color: "#fff",
                                                        fontSize: "5rem",
                                                      }}
                                                    >
                                                      +
                                                    </div>
                                                  </div>
                                                )}

                                                {/* Default icon when no image */}
                                                {/* {!coverImage && !edittrue && (
                                                <div>
                                                  <i className="fa fa-image mb-2" style={{ fontSize: "2rem", color: "#fff" }}></i>
                                                </div>
                                              )} */}
                                              </label>
                                            </div>

                                            {/* Profile Image Input */}
                                            <div
                                              className="profile-image-wrapper mx-auto d-flex align-items-center justify-content-center"
                                              style={{
                                                transform: "translateY(-50%)",
                                                zIndex: 3,
                                                position: "relative",
                                              }}
                                            >
                                              <div
                                                className="profile-image rounded-circle"
                                                style={{
                                                  width: "120px",
                                                  height: "120px",
                                                  border: "10px solid #1e1f25",
                                                  position: "relative",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                <input
                                                  type="file"
                                                  id="profileImageInput"
                                                  accept="image/*"
                                                  className="image-input"
                                                  onChange={(e) =>
                                                    handleProfileImageChange(e)
                                                  }
                                                  style={{
                                                    opacity: 0,
                                                    position: "absolute",
                                                    height: "100%",
                                                    width: "100%",
                                                    cursor: edittrue
                                                      ? "pointer"
                                                      : "default",
                                                    zIndex: 2,
                                                    pointerEvents: edittrue
                                                      ? "auto"
                                                      : "none", // Disable interaction when not in edit mode
                                                  }}
                                                  disabled={!edittrue}
                                                />
                                                <label
                                                  htmlFor="profileImageInput"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                    height: "100%",
                                                    cursor: edittrue
                                                      ? "pointer"
                                                      : "default",
                                                    position: "relative",
                                                  }}
                                                >
                                                  {/* Profile image display */}
                                                  {profileImage ? (
                                                    <img
                                                      src={URL.createObjectURL(
                                                        profileImage
                                                      )}
                                                      alt="Profile"
                                                      className="img-fluid rounded-circle"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "100%",
                                                        objectFit: "cover",
                                                      }}
                                                    />
                                                  ) : databaseimage ? (
                                                    <img
                                                      src={
                                                        API_URL +
                                                        "images/" +
                                                        databaseimage
                                                      }
                                                      alt="Profile"
                                                      className="img-fluid rounded-circle"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "100%",
                                                        objectFit: "cover",
                                                      }}
                                                    />
                                                  ) : (<img
                                                    src={`default-images/default_user_image.jpg`}
                                                    alt="Cover Preview"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      objectFit: "cover",
                                                      borderRadius: "10px",
                                                    }}
                                                  />)}

                                                  {/* Edit mode overlay with + icon */}
                                                  {edittrue && (
                                                    <div
                                                      className="edit-overlay"
                                                      style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.5)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius: "50%",
                                                      }}
                                                    >
                                                      <div
                                                        className="plus-icon"
                                                        style={{
                                                          color: "#fff",
                                                          fontSize: "3rem",
                                                        }}
                                                      >
                                                        +
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* Default icon when no image and not in edit mode */}
                                                  {!profileImage &&
                                                    !edittrue && <></>}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="row gx-2"
                                            style={{ marginTop: "-40px" }}
                                          >
                                            <fieldset>
                                              <div className="row">
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom01"
                                                >
                                                  <input
                                                    type="text"
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="First name"
                                                    required
                                                    disabled={!edittrue}
                                                    value={userdata.firstname}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    name={"firstname"}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter a first name.
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <input
                                                    type="text"
                                                    name="lastname"
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="Last name"
                                                    required
                                                    value={userdata.lastname}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    disabled={!edittrue}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter a last name.
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom03"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  name={"business_name"}
                                                  required
                                                  placeholder="Business Name"
                                                  disabled={!edittrue}
                                                  value={userdata.business_name}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please enter a business name.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom03"
                                              >
                                                <input
                                                  type="tel"
                                                  className="form-control dashboard-input-box-3"
                                                  name={"phone"}
                                                  required
                                                  placeholder="Phone Number"
                                                  disabled={!edittrue}
                                                  value={userdata.phone}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please enter a 8-digit phone
                                                  number.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="email"
                                                  className="form-control dashboard-input-box-3"
                                                  name="email"
                                                  placeholder="Email"
                                                  disabled={!edittrue}
                                                  value={userdata.email}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a email.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  disabled={!edittrue}
                                                  value={userdata.website_url}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                  name="website_url"
                                                  placeholder="Website URL..."
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a website.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div className="row">
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <select
                                                    name="country"
                                                    disabled={!edittrue}
                                                    value={userdata.country}
                                                    onChange={(e) => {
                                                      dataChange(e);
                                                      getallstatefunc(
                                                        e.target.value
                                                      );
                                                    }}
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    <option value={0}>
                                                      Country
                                                    </option>
                                                    {countrylist &&
                                                      countrylist.map(
                                                        (item) => (
                                                          <option
                                                            value={item._id}
                                                            key={item._id}
                                                          >
                                                            {item.name}
                                                          </option>
                                                        )
                                                      )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please choose country
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom02"
                                                >
                                                  <select
                                                    name="state"
                                                    disabled={!edittrue}
                                                    value={userdata.state}
                                                    onChange={(e) => {
                                                      dataChange(e);
                                                      getallcityfunc(
                                                        e.target.value
                                                      );
                                                    }}
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    {/* <option value={0}>
                                                      State
                                                    </option>
                                                    {statelist &&
                                                      statelist.map((item) => (
                                                        <option
                                                          value={item._id}
                                                          key={item._id}
                                                        >
                                                          {item.name}
                                                        </option>
                                                      ))} */}
                                                    {stateLoading ? (
                                                      <option disabled>Loading...</option>
                                                    ) : (
                                                      <>
                                                        <option value={0}>State</option>
                                                        {statelist &&
                                                          statelist.map((item) => (
                                                            <option value={item._id} key={item._id}>
                                                              {item.name}
                                                            </option>
                                                          ))}
                                                      </>
                                                    )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter State
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              <div
                                                className="col-md-12 form-group"
                                                controlid="validationCustom04"
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control dashboard-input-box-3"
                                                  disabled={!edittrue}
                                                  value={userdata.address}
                                                  onChange={(e) =>
                                                    dataChange(e)
                                                  }
                                                  name="address"
                                                  placeholder="Street Address, Apt. #"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  Please choose a street
                                                  address.
                                                </Form.Control.Feedback>
                                              </div>
                                              <div className="row">
                                                <div
                                                  className="col-md-6 form-group"
                                                  controlid="validationCustom01"
                                                >
                                                  <select
                                                    name="city"
                                                    disabled={!edittrue}
                                                    value={userdata.city}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Default select example"
                                                  >
                                                    {/* <option value={0}>
                                                      City/Town
                                                    </option>
                                                    {citylist &&
                                                      citylist.map((item) => (
                                                        <option
                                                          value={item._id}
                                                          key={item._id}
                                                        >
                                                          {item.name}
                                                        </option>
                                                      ))} */}
                                                    {cityLoading ? (
                                                      <option disabled>Loading...</option>
                                                    ) : (
                                                      <>
                                                        <option value={0}>City/Town</option>
                                                        {citylist &&
                                                          citylist.map((item) => (
                                                            <option value={item._id} key={item._id}>
                                                              {item.name}
                                                            </option>
                                                          ))}
                                                      </>
                                                    )}
                                                  </select>
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter City
                                                  </Form.Control.Feedback>
                                                </div>
                                                <div
                                                  className="col-md-6 form-group "
                                                  controlid="validationCustom02"
                                                >
                                                  <input
                                                    type="text"
                                                    name="zip"
                                                    disabled={!edittrue}
                                                    value={userdata.zip}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    className="form-control dashboard-input-box-3"
                                                    placeholder="Zip Code"
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    Please enter Zip Code
                                                  </Form.Control.Feedback>
                                                </div>
                                              </div>
                                              {/* <div className="row">
                                                <div
                                                  className="col-md-12 form-group mb-0"
                                                  controlid="validationCustom015"
                                                >
                                                  <textarea
                                                    className="dashboard-text-area"
                                                    name="bio"
                                                    disabled={!edittrue}
                                                    value={userdata.bio}
                                                    onChange={(e) =>
                                                      dataChange(e)
                                                    }
                                                    rows="3"
                                                    placeholder="Bio..."
                                                  ></textarea>
                                                </div>
                                              </div> */}
                                              <div className="row">
                                                <div
                                                  className="col-md-12 form-group"
                                                  controlid="validationCustom04"
                                                  style={{ position: 'relative' }}
                                                >
                                                  <input
                                                    type="file"
                                                    name="zip"
                                                    accept="video/*"
                                                    onChange={handleBioVideo}
                                                    disabled={!edittrue}
                                                    className="form-control dashboard-input-box-3"
                                                    style={{
                                                      backgroundColor: "rgb(65 70 79)",
                                                      borderRadius: "10px",
                                                      cursor: edittrue ? "pointer" : "not-allowed",
                                                      color: "transparent", // hides default text
                                                      textIndent: "-9999px", // pushes text offscreen
                                                    }}
                                                  />
                                                  <div
                                                    style={{
                                                      transform: "translateY(-125%)",
                                                      padding: "10px 25px",
                                                      color: "#ffffff",
                                                      display: "flex",
                                                      fontSize: "18.5px",
                                                      fontWeight: "normal",
                                                      alignItems: "center",
                                                      justifyContent: "space-between",
                                                      pointerEvents: "none", // allows clicking input below
                                                    }}
                                                    className="levivating-text"
                                                  >
                                                    <span style={{ color: "#ffffff" }}>Upload Bio Video</span>
                                                    <FiUpload size={24} strokeWidth={3} />
                                                  </div>
                                                </div>
                                                <style>
                                                  {`
                                                        @media only screen and (min-width: 992px) and (max-width: 1440px) {
                                                            .levivating-text{
                                                                transform: translateY(-115%) !important;
                                                            }
                                                        }
                                                        @media only screen and (max-width: 480px) {
                                                          .levivating-text{
                                                              transform: translateY(-118%) !important;
                                                              font-size: 16px !important;
                                                          }
                                                              .levitating-icon{
                                                              font-size: 20px !important;
                                                              }
                                                      }

                                                    `}
                                                </style>
                                              </div>

                                              {(bioVideo || databasebiovideo) && (
                                                <div className="row" style={{ marginTop: "-3rem" }}>
                                                  <div
                                                    className="col-md-12 form-group mb-0"
                                                    controlid="validationCustom015"
                                                  >
                                                    <div
                                                      className="video-container1"
                                                      style={{
                                                        backgroundSize: "cover",
                                                        backgroundPosition:
                                                          "center",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        borderRadius: "15px",
                                                      }}
                                                    >
                                                      <video
                                                        key={bioVideo ? bioVideo.name : databasebiovideo}
                                                        playsInline
                                                        autoPlay={false}
                                                        controls
                                                        preload="metadata"
                                                        style={{
                                                          width: "100%",
                                                          height: "100%",
                                                          borderRadius: "10px",
                                                        }}
                                                        controlsList="nodownload"
                                                      >
                                                        <source
                                                          src={
                                                            bioVideo
                                                              ? URL.createObjectURL(bioVideo)
                                                              : API_URL + "attachment/" + databasebiovideo + "#t=0.1"
                                                          }
                                                          type="video/mp4"
                                                        />
                                                        Your browser does not
                                                        support HTML5 video.
                                                      </video>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </fieldset>
                                          </div>
                                        </Form>
                                      </div>
                                    </Tab>
                                    <Tab eventKey="project" title="Projects">
                                      <div className="">
                                        <>
                                          {filteredData.length === 0 ? (
                                            <div className="black_bg_box mt-0">
                                              <div className="no-data-img">
                                                <img
                                                  src={require("../assets/images/logo_text.png")}
                                                  alt=""
                                                />
                                              </div>
                                              <div className="no-data-text">
                                                <h3>No projects to show</h3>
                                              </div>
                                            </div>
                                          ) : (
                                            filteredData &&
                                            filteredData.map((item, i) => {
                                              return (
                                                <div className="black_bg_box mt-0">
                                                  {item?.submitted_status ===
                                                    0 ? (
                                                    <>
                                                      <div className="black_bg_box_inner">
                                                        <div className="left_box_content">
                                                          <div className="list_border_boxs project-list-box">
                                                            <div className="border_box_view">
                                                              <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                  {/* {getsvgicon(item.current_stage)} */}
                                                                  <svg
                                                                    viewBox="-42 0 512 512.002"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="#99ea24"
                                                                  >
                                                                    <path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                                                                    <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                                                                  </svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                  <div className="little_text">
                                                                    Customer:
                                                                  </div>
                                                                  <div className="big_text">
                                                                    {item &&
                                                                      item.firstname +
                                                                      " " +
                                                                      item.lastname}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="border_box_view">
                                                              <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                  <FaCalendarAlt />
                                                                </div>
                                                                <div className="box_text_content">
                                                                  {/* <div className="little_text">Start Date:</div>
                                                                                                                                    <div className="big_text">{item && formatDate(item.createdAt)}</div> */}
                                                                  <div className="little_text">
                                                                    Status:
                                                                  </div>
                                                                  <div className="big_text">
                                                                    Open Fitting
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="right_box_content">
                                                          <div className="box_btn">
                                                            {item.studio_fitting ===
                                                              0 ? (
                                                              <Link
                                                                to={`/remote_fittings_camera/${item.user_id}`}
                                                              >
                                                                <button className="btn customer_btn_view">
                                                                  <IoMdEye />
                                                                </button>
                                                              </Link>
                                                            ) : (
                                                              <Link
                                                                to={`/remote_fittings_studio/${item.user_id}`}
                                                              >
                                                                <button className="btn customer_btn_view">
                                                                  <IoMdEye />
                                                                </button>
                                                              </Link>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <div className="black_bg_box_inner">
                                                        <div className="left_box_content">
                                                          <div className="list_border_boxs project-list-box">
                                                            <div className="border_box_view">
                                                              <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                  {getsvgicon(
                                                                    item.current_stage
                                                                  )}
                                                                </div>
                                                                <div className="box_text_content">
                                                                  <div className="little_text">
                                                                    Status:
                                                                  </div>
                                                                  <div className="big_text">
                                                                    {item &&
                                                                      getcurrentstage(
                                                                        item?.current_stage
                                                                      )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="border_box_view">
                                                              <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                  <FaCalendarAlt />
                                                                </div>
                                                                <div className="box_text_content">
                                                                  <div className="little_text">
                                                                    Start Date:
                                                                  </div>
                                                                  <div className="big_text">
                                                                    {item &&
                                                                      formatDate(
                                                                        item.createdAt
                                                                      )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="right_box_content">
                                                          <div className="box_btn">
                                                            <button
                                                              className="btn customer_btn_view"
                                                              onClick={(e) => {
                                                                // showstagespopup();
                                                                setStatus(
                                                                  item.category
                                                                );
                                                                setCustomername(
                                                                  item.firstname +
                                                                  " " +
                                                                  item.lastname
                                                                );
                                                                setChecktype(
                                                                  item.type
                                                                );
                                                                // setRemortFittingFormData(item)
                                                                getremoteInquiryapifunc(
                                                                  item?._id
                                                                );
                                                              }}
                                                            >
                                                              <IoMdEye />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                </div>
                                              );
                                            })
                                          )}
                                        </>
                                      </div>
                                    </Tab>
                                    <Tab eventKey="posts" title="Posts">
                                      <div className="jhcgchcvuvu">
                                        <>
                                          <div className="tab-form-header my-4">
                                            <h3 className="text-white">
                                              My Posts
                                            </h3>

                                            {activepost ? (
                                              <div className="sec-btn-group d-flex justify-content-end">
                                                <button
                                                  className="btn tab_form_btn"
                                                  disabled
                                                  style={{
                                                    backgroundColor: "#1e1f25",
                                                    height: "55px",
                                                    border: "none",
                                                  }}
                                                >
                                                  create
                                                </button>
                                              </div>
                                            ) : (
                                              <button
                                                className="btn tab_form_btn"
                                                onClick={handleactivepost}
                                                style={{
                                                  backgroundColor: "#1e1f25",
                                                  height: "55px",
                                                  border: "none",
                                                }}
                                              >
                                                create
                                              </button>
                                            )}
                                          </div>
                                          {activepost && (
                                            <div className="black_bg_box mt-0 ">
                                              <Form
                                                noValidate
                                                validated={validated}
                                                onSubmit={handleSubmit}
                                              >
                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom011"
                                                  >
                                                    <div className="custom-file-upload">
                                                      <input
                                                        name="image"
                                                        type="file"
                                                        required
                                                        ref={fileInputRef}
                                                        className="file-input-hidden"
                                                        onChange={(e) => {
                                                          const file =
                                                            e.target.files[0];
                                                          if (file) {
                                                            setimage(file);
                                                            setImagePreview(
                                                              URL.createObjectURL(
                                                                file
                                                              )
                                                            );
                                                          }
                                                        }}
                                                      />
                                                      <div className="file-upload-placeholder">
                                                        {imagePreview ? (
                                                          <img
                                                            src={imagePreview}
                                                            alt="Preview"
                                                            style={{
                                                              maxHeight: "100%",
                                                              maxWidth: "100%",
                                                            }}
                                                          />
                                                        ) : (
                                                          <FiImage
                                                            size={60}
                                                            color="#ffffff"
                                                          />
                                                        )}
                                                        {/* <FiImage size={60} color="#ffffff" /> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom012"
                                                  >
                                                    <input
                                                      name="title"
                                                      type="text"
                                                      required
                                                      className="form-control dashboard-input-box-3"
                                                      value={title}
                                                      onChange={(e) =>
                                                        setTitle(e.target.value)
                                                      }
                                                      placeholder="Title your post here...."
                                                    />
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div
                                                    className="col-md-12 form-group"
                                                    controlid="validationCustom013"
                                                  >
                                                    <textarea
                                                      name="descripation"
                                                      className="dashboard-text-area"
                                                      value={descripation}
                                                      onChange={(e) =>
                                                        setDescripation(
                                                          e.target.value
                                                        )
                                                      }
                                                      rows="5"
                                                      placeholder="Write a description for your post..."
                                                      required
                                                    ></textarea>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div className="col-sm-6 col-12 form-group mb-0">
                                                    {postsloader ? (
                                                      <button
                                                        className="btn btn-create"
                                                        disabled
                                                      >
                                                        Saving....
                                                      </button>
                                                    ) : (
                                                      <button
                                                        className="btn btn-create"
                                                        type="submit"
                                                      >
                                                        Save Post
                                                      </button>
                                                    )}
                                                  </div>
                                                  <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                    <button
                                                      className="btn btn-create ubuyuy"
                                                      onClick={removepostdata}
                                                      style={{
                                                        backgroundColor:
                                                          "#f34c12 !important",
                                                      }}
                                                    >
                                                      Remove Post
                                                    </button>
                                                  </div>
                                                </div>


                                              </Form>
                                            </div>
                                          )}

                                          {postdata.length === 0 ? (
                                            <div className="black_bg_box mt-0">
                                              <div className="no-data-img">
                                                <img
                                                  src={require("../assets/images/logo_text.png")}
                                                  alt=""
                                                />
                                              </div>
                                              <div className="no-data-text">
                                                <h3>No posts to show</h3>
                                              </div>
                                            </div>
                                          ) : (
                                            postdata &&
                                            postdata.map((item, i) => {
                                              return (
                                                <div
                                                  className="black_bg_box mt-0"
                                                  key={i}
                                                >
                                                  {/* Image */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <input
                                                          type="file"
                                                          onChange={
                                                            handleImageChange
                                                          }
                                                          className="form-control"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                            color: "#ffffff"
                                                          }}
                                                        />
                                                      ) : (
                                                        <div
                                                          className="profile-image-container text-center"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            height: "20rem",
                                                            borderRadius:
                                                              "10px",
                                                            position:
                                                              "relative",
                                                            display: "flex", alignItems: "center", justifyContent: "center"
                                                          }}
                                                        >
                                                          <img
                                                            src={
                                                              API_URL +
                                                              `posts/` +
                                                              item?.post_image
                                                            }
                                                            alt="Post"
                                                            style={{
                                                              maxWidth: "100%",
                                                              maxHeight: "100%",
                                                              objectFit:
                                                                "cover",
                                                              borderRadius: "10px"
                                                            }}
                                                          />
                                                          <div
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{
                                                              width: "2rem",
                                                              height: "2rem",
                                                              borderRadius:
                                                                "5px",
                                                              backgroundColor:
                                                                "#ffffff",
                                                              position:
                                                                "absolute",
                                                              bottom: "10px",
                                                              right: "10px",
                                                              transform: "",
                                                            }}
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              setSelectedImage(API_URL + "posts/" + item?.post_image);
                                                            }}
                                                          >
                                                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 512 512" width="512" data-name="Layer 1" fill=""><path d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z" fill-rule="evenodd" fill="#99ea24" /></svg>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Title */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <input
                                                          type="text"
                                                          name="title"
                                                          value={
                                                            editedPost.title ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          className="form-control"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                            color: "#ffffff"
                                                          }}
                                                          placeholder="Enter title"
                                                        />
                                                      ) : (
                                                        <p
                                                          className="text-white mb-2"
                                                          style={{
                                                            fontSize: "22px",
                                                          }}
                                                        >
                                                          {item.title}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Description */}
                                                  <div className="row">
                                                    <div className="col-md-12 form-group">
                                                      {editIndex === i ? (
                                                        <textarea
                                                          name="descripation"
                                                          value={
                                                            editedPost.descripation ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          className="form-control"
                                                          style={{
                                                            backgroundColor:
                                                              "#41464f",
                                                            borderRadius:
                                                              "10px",
                                                            border: "none",
                                                            color: "#ffffff"
                                                          }}
                                                          rows="3"
                                                          placeholder="Enter description"
                                                        ></textarea>
                                                      ) : (
                                                        <p
                                                          style={{
                                                            // width: "337.5px",
                                                            // height: "59.5px",

                                                            fontSize: "16px",
                                                            fontWeight: 500,
                                                            fontStyle: "normal",
                                                            lineHeight: 2,
                                                            letterSpacing:
                                                              "normal",
                                                            textAlign: "left",
                                                            color: "#ffffff",
                                                          }}
                                                          className="mb-2"
                                                        >
                                                          {item.descripation}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Action Buttons */}
                                                  <div className="row">
                                                    {editIndex === i ? (
                                                      <>
                                                        <div className="col-sm-6 col-12 form-group mb-0">
                                                          <button
                                                            className="btn btn-create"
                                                            onClick={handleSave}
                                                            disabled={
                                                              UpdatePostLoader
                                                            }
                                                          >
                                                            {UpdatePostLoader
                                                              ? "editing..."
                                                              : "Edit Post"}
                                                          </button>
                                                        </div>
                                                        <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                          <button
                                                            className="btn btn-create ubuyuy"
                                                            onClick={handleCancel}
                                                          >
                                                            Remove Post
                                                          </button>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <div className="col-sm-6 col-12 form-group mb-0">
                                                          <button
                                                            className="btn btn-create vergrgre"
                                                            onClick={() =>
                                                              handleEditClick(
                                                                i,
                                                                item
                                                              )
                                                            }
                                                          >
                                                            Edit Post
                                                          </button>
                                                        </div>
                                                        <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                          <button
                                                            className="btn btn-create ubuyuy"
                                                            onClick={() => {
                                                              handleShowremovepostpop();
                                                              setPostId(item?._id)
                                                            }}
                                                          >
                                                            Remove Post
                                                          </button>
                                                        </div>
                                                      </>
                                                    )}
                                                  </div>

                                                  {selectedImage && (
                                                    <div
                                                      className="modal-overlay"
                                                      style={{
                                                        position: "fixed",
                                                        top: 0, left: 0, right: 0, bottom: 0,
                                                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        zIndex: 9999
                                                      }}
                                                      onClick={() => setSelectedImage(null)} // click to close
                                                    >
                                                      <img
                                                        src={selectedImage}
                                                        alt="Zoomed"
                                                        style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }}
                                                      />
                                                    </div>
                                                  )}
                                                  {/* <div className="col-sm-6 col-12 eferfefef form-group mb-0">
                                                      <button
                                                        className="btn btn-create ubuyuy"
                                                        onClick={handleCancel}
                                                      >
                                                        Remove Post
                                                      </button>
                                                    </div> */}
                                                </div>
                                              );
                                            })
                                          )}
                                          <style>{`
                                                @media screen and (max-width: 575px){
                                                    .jhcgchcvuvu .eferfefef{
                                                      margin-top: 10px;
                                                    }
                                                }
                                                @media screen and (max-width: 450px){
                                                    .jhcgchcvuvu .btn-create{
                                                      font-size: 16px;
                                                    }
                                                }
                                                .jhcgchcvuvu .btn-create.ubuyuy{
                                                  background-color: #f34c12 !important;
                                                  color: #ffffff !important;
                                                }
                                                .jhcgchcvuvu .btn-create.vergrgre{
                                                  background-color: #404650 !important;
                                                  color: #ffffff !important;
                                                }
                                                .jhcgchcvuvu .btn-create, .jhcgchcvuvu .ubuyuy{
                                                    font-weight: 600 !important;
                                                  }
                                                .jhcgchcvuvu .custom-file-upload {
                                                      position: relative;
                                                      height: 15rem;
                                                      border-radius: 15px;
                                                      display: flex;
                                                      align-items: center;
                                                      justify-content: center;
                                                      cursor: pointer;
                                                      overflow: hidden;
                                                      background-color: #41464f;
                                                      transition: all 0.3s ease;
                                                    }
                                                    
                                                    .jhcgchcvuvu .custom-file-upload:hover {
                                                      border-color: #666;
                                                      background-color: #f0f0f0;
                                                    }
                                                    
                                                    .jhcgchcvuvu .file-input-hidden {
                                                      position: absolute;
                                                      top: 0;
                                                      left: 0;
                                                      width: 100%;
                                                      height: 100%;
                                                      opacity: 0;
                                                      cursor: pointer;
                                                      z-index: 2;
                                                    }
                                                    
                                                    .jhcgchcvuvu .file-upload-placeholder {
                                                      display: flex;
                                                      flex-direction: column;
                                                      align-items: center;
                                                      justify-content: center;
                                                      text-align: center;
                                                      color: #666;
                                                    }
                                                    
                                                    .jhcgchcvuvu .upload-icon {
                                                      font-size: 2rem;
                                                      margin-bottom: 0.5rem;
                                                      color: #666;
                                                    }
                                                  `}</style>
                                        </>
                                      </div>
                                    </Tab>
                                  </Tabs>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>
            {`
.user_desk_tab.vhjgvjh .nav-item {
                    width: 50% !important;
                }
                .user_desk_tab.vhjgvjh .nav-item .nav-link {
                    background-color: transparent;
                    color: #ffffff;
                    border-radius: 20px;
                    font-size: 18px;
                    font-weight: 800;
                    height: 75px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .user_desk_tab.vhjgvjh .nav-item .nav-link.active {
                    background-color: #99ea24;
                    color: #262a31;
                }
                .user_desk_tab.vhjgvjh {
                    // background:rgba(46, 47, 50, 1);
                    background: #1e2025;
                    border-radius: 20px;
                }



                                .bg_dark_black.card-dark.card-radius.dark_modal_mobile.cewfefew{
                                    background-color: #252a31;
                                }

                                .black_bg_box.progress-box.nuiohiuh{
                                    padding: 40px 25px 25px 25px;
                                }

                                @media screen and (min-width: 320px) and (max-width: 600px){
                                    .modal-dialog {
                                        margin-top: 0 !important;
                                    }
                                }

                                @media only screen and (min-width: 992px) and (max-width: 1279px) {
                                    .black_bg_box.progress-box {
                                        padding: 25px;
                                        margin: 20px 0 !important;
                                    }
                                    .black_bg_box.progress-box.nuiohiuh{
                                        padding: 40px 25px 25px 25px;
                                    }
                                }

                                @media only screen and (min-width: 1280px) and (max-width: 1600px) {
                                    .black_bg_box.progress-box {
                                        margin: 20px 0 !important;
                                    }
                                }

                                @media only screen and (min-width: 1601px) and (max-width: 1919px) {
                                    .black_bg_box.progress-box {
                                        margin: 20px 0;
                                    }
                                }

                                @media only screen and (min-width: 768px) and (max-width: 991px){
                                    .black_bg_box.progress-box.vwfefe {
                                      padding: 20px 25px; 
                                      border-radius: 20px;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 767px) {
                                    .black_bg_box.progress-box.vwfefe {
                                      padding: 20px 25px; 
                                      border-radius: 20px;
                                    }
                                }

                                @media only screen and (min-width: 992px) and (max-width: 1279px) {
                                    .black_bg_box.progress-box.vwfefe {
                                      padding: 20px 25px; 
                                      border-radius: 20px;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .tab-box-section.my-4 {
                                      padding: 25px 10px;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .results-accordion .accordion-header .accordion-button {
                                        padding: 0px 10px;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .results-accordion .accordion-header .accordion-button .gab_title .gab_text h5 {
                                        font-size: 16px;
                                        gap: 10px;
                                    }
                                    .results-accordion .accordion-header .accordion-button .gab_title .gab_text h5 .light-text{
                                      white-space: nowrap;
                                      overflow: hidden;
                                      text-overflow: ellipsis;
                                      width: 90px;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 767px) {
                                    .black_bg_box.progress-box {
                                        padding: 30px 30px;
                                        margin: 20px 0px;
                                        border-radius: 30px;
                                    }

                                    .black_bg_box.progress-box.nuiohiuh{
                                        padding: 40px 30px 30px 30px;
                                    }

                                    .black_bg_box.progress-box .big_text, .black_bg_box.progress-box .progress-item-title {
                                        font-size: 20px;
                                    }
                                }

                                @media only screen and (min-width: 768px) and (max-width: 991px) {
                                    .black_bg_box.progress-box .big_text, .black_bg_box.progress-box .progress-item-title {
                                        font-size: 22px;
                                    }
                                }

                                @media only screen and (min-width: 767px) and (max-width: 991px) {
                                    .card-dark {
                                        padding: 2.2rem;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .card-dark.dark_modal_mobile {
                                        padding: 25px 16px;
                                    }
                                }

                                @media only screen and (min-width: 991px) {
                                  .newnewnew label{
                                    margin-top: -10px !important;
                                  }
                                }

                                @media only screen and (min-width: 767px) and (max-width: 991px){
                                  .newnewnew label{
                                    margin-top: -10px !important;
                                  }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 767px){
                                  .newnewnew label{
                                    margin-top: -10px !important;
                                  }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 475px){
                                  .newnewnew .row.mb-3.d-flex.align-items-center{
                                    gap: 10px;
                                    margin-right: -70px;
                                  }
                                    .newnewnew .row.mb-3.d-flex.align-items-center .col-5.col-sm-5.mb-3{
                                      width: 35%;
                                    }
                                }
                            `}
          </style>
        </>
      )}
    </>
  );
}

const getcurrentstage = (current_stage) => {
  switch (current_stage) {
    case "0":
      return "Fitting";
    case "1":
      return "Perscription";
    case "2":
      return "Build sheet";
    case "3":
      return "Staging station";
    case "4":
      return "Build station";
    case "5":
      return "Ship station";
    case "6":
      return "Complete";
    default:
      return ""; // In case the status doesn't match any case
  }
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = String(date.getUTCFullYear()).slice(-2);
  return `${month}/${day}/${year}`;
};

const getsvgicon = (current_stage) => {
  switch (current_stage) {
    case "0":
      return (
        <svg
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="#99ea24">
            <path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" />
            <path
              clip-rule="evenodd"
              d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z"
              fill-rule="evenodd"
            />
          </g>
        </svg>
      );
    case "1":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
        >
          <g fill="#99ea24">
            <path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" />
            <g clip-rule="evenodd" fill-rule="evenodd">
              <path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" />
              <path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" />
            </g>
          </g>
        </svg>
      );
    case "2":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
        >
          <g fill="#99ea24">
            <path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" />
            <path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" />
            <path
              clip-rule="evenodd"
              d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z"
              fill-rule="evenodd"
            />
          </g>
        </svg>
      );
    case "3":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
        >
          <g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd">
            <path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-11 37c0-1.1046-.8954-2-2-2h-5c-1.1046 0-2 .8954-2 2s.8954 2 2 2h5c1.1046 0 2-.8954 2-2z" />
            <path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2 10c0-1.1046-.8954-2-2-2s-2 .8954-2 2v6.5c0 1.1046.8954 2 2 2h6.5c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-4.5z" />
          </g>
        </svg>
      );
    case "4":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
        >
          <g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd">
            <path d="m15.2752 2c-4.0003 0-7.61569 2.38397-9.19148 6.06081l-4.08372 9.52869v24.4105c0 6.6274 5.37258 12 12 12h14.7613c-1.1303-2.4315-1.7613-5.142-1.7613-8 0-10.4934 8.5066-19 19-19 2.858 0 5.5685.631 8 1.7613v-11.1718l-4.0837-9.52869c-1.5758-3.67684-5.1912-6.06081-9.1915-6.06081zm-5.5149 7.63648c.9455-2.2061 3.1147-3.63648 5.5149-3.63648h10.7248v10h-18.96692zm20.2397 6.36352v-10h10.7248c2.4002 0 4.5694 1.43038 5.5149 3.63649l2.7272 6.36351zm-13 25c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.1046 0-2-.8954-2-2s.8954-2 2-2z" />
            <path d="m30 46c0-8.8366 7.1634-16 16-16s16 7.1634 16 16-7.1634 16-16 16-16-7.1634-16-16zm24 0c0 1.1046-.8954 2-2 2h-4v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4h-4c-1.1046 0-2-.8954-2-2s.8954-2 2-2h4v-4c0-1.1046.8954-2 2-2s2 .8954 2 2v4h4c1.1046 0 2 .8954 2 2z" />
          </g>
        </svg>
      );
    case "5":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
        >
          <g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd">
            <path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-15 34c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.10457 0-2-.8954-2-2s.89543-2 2-2z" />
            <path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2.5858 15.4142c.781.7811 2.0474.7811 2.8284 0 .7811-.781.7811-2.0474 0-2.8284l-4-4c-.781-.7811-2.0474-.7811-2.8284 0l-4 4c-.7811.781-.7811 2.0474 0 2.8284.781.7811 2.0474.7811 2.8284 0l.5858-.5858v7.1716c0 1.1046.8954 2 2 2s2-.8954 2-2v-7.1716z" />
          </g>
        </svg>
      );
    case "6":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          height="512"
          viewBox="0 0 512 512"
          width="512"
          data-name="Layer 1"
        >
          <g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd">
            <path d="m258 404.93a141.07 141.07 0 0 1 236.79-103.61q1-72.31-1.2-144.62c-.8-33.12-19.5-66.37-50.83-82.8-16.1-8.51-32.78-16.7-49.65-24.46-66.66 21.56-144.73 50-223.47 85.21a44.44 44.44 0 0 0 -26.43 38.68c-1.23 38-1.61 77.22-1.11 116a5.32 5.32 0 0 1 -9.61 3.33q-12.5-16-24.42-31.64a4 4 0 0 0 -5.31-1.09q-9.27 5.52-18.21 10.89c-3.34 2-7.45-.67-7.47-4.78-.2-38.63.76-77.36 2.83-114.9.87-15.83 10.8-30.74 25.49-38 75.52-37.3 156.09-67.77 224.84-90.32-16-6.26-31.91-12-47.44-17.44a99.49 99.49 0 0 0 -64.62 0c-51.82 17.88-108.41 41.22-159.97 68.52-31.32 16.43-50 49.68-50.83 82.8q-3.06 99.3 0 198.6c.8 33.12 19.51 66.37 50.83 82.8 51.56 27.3 108.15 50.64 160 68.51a99.49 99.49 0 0 0 64.62 0q6.79-2.34 13.71-4.83a140.07 140.07 0 0 1 -38.54-96.85z" />
            <path d="m399.07 297.87a107.07 107.07 0 1 0 107.08 107.06 107.07 107.07 0 0 0 -107.08-107.06zm61.07 89.34-64.36 67.58a18.84 18.84 0 0 1 -13.58 5.86h-.09a18.91 18.91 0 0 1 -13.55-5.73l-34.15-35.18a18.88 18.88 0 0 1 27.1-26.3l20.49 21.09 50.81-53.36a18.88 18.88 0 0 1 27.35 26z" />
          </g>
        </svg>
      );
    default:
      return ""; // In case the status doesn't match any case
  }
};

function checkActive(data, category) {
  return data?.[category]?.status === "1" ? "active" : "inactive";
}

function checkActiveForComplete(status) {
  //check if status.shipstation.messages have 2 messages then return true
  if (
    status.shipstation &&
    status.shipstation.messages &&
    status.shipstation.messages.length > 1
  ) {
    return "active";
  }
  return "inactive";
}

export default Fitter;
